export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /** Time (isoformat) */
  Time: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

/** Gemini/Vertex AI verification of task completion imagery for one ActionComplete. */
export type AIActionCheckResultFilter = {
  AND?: InputMaybe<AIActionCheckResultFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<AIActionCheckResultFilter>;
  OR?: InputMaybe<AIActionCheckResultFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  passed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ActionComplete(created, modified, id, completed_by, action, start_time, end_time) */
export type ActionCompleteFilter = {
  AND?: InputMaybe<ActionCompleteFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionCompleteFilter>;
  OR?: InputMaybe<ActionCompleteFilter>;
  action?: InputMaybe<ActionFilter>;
  aiCheckResult?: InputMaybe<AIActionCheckResultFilter>;
  completedBy?: InputMaybe<UserFilter>;
  endTime?: InputMaybe<DatetimeDateFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<DatetimeDateFilterLookup>;
};

export type ActionCompleteInput = {
  actionId: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ActionCompleteOrder = {
  endTime?: InputMaybe<Ordering>;
};

/** Action(created, modified, id, action_type, created_by, tenant, action_group, action_shift, master_category_id, title, description, due_date_time, ongoing, is_restock, ai_image_check, store, due_date, status, action_generator, closed_by, closed_date, parent_action) */
export type ActionFilter = {
  AND?: InputMaybe<ActionFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionFilter>;
  OR?: InputMaybe<ActionFilter>;
  actionGenerator?: InputMaybe<ActionGeneratorFilter>;
  actionGroup?: InputMaybe<ActionGroupFilter>;
  actionShift?: InputMaybe<ActionShiftFilter>;
  actionType?: InputMaybe<ActionTypeBaseFilterLookup>;
  /** If true, completed task images may be verified by AI after completion. */
  aiImageCheck?: InputMaybe<Scalars['Boolean']['input']>;
  closedBy?: InputMaybe<UserFilter>;
  completions?: InputMaybe<ActionCompleteFilter>;
  createdBy?: InputMaybe<UserFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<DatetimeDateFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, this action is a restock task. Use action_type to determine if a scan/image is required. */
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  isSubAction?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<ActionNoteFilter>;
  /** If true, the action can be completed multiple times throughout the day */
  ongoing?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ActionStatus>;
  store?: InputMaybe<StoreFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** ActionGenerator(created, modified, id, action_type, created_by, tenant, action_group, action_shift, master_category_id, title, description, due_date_time, ongoing, is_restock, ai_image_check, is_system_action, start_date, end_date, repeat_schedule, parent_generator, product_set) */
export type ActionGeneratorFilter = {
  AND?: InputMaybe<ActionGeneratorFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionGeneratorFilter>;
  OR?: InputMaybe<ActionGeneratorFilter>;
  actionGroup?: InputMaybe<ActionGroupFilter>;
  actionShift?: InputMaybe<ActionShiftFilter>;
  actionType?: InputMaybe<ActionTypeBaseFilterLookup>;
  actions?: InputMaybe<ActionFilter>;
  /** If true, completed task images may be verified by AI after completion. */
  aiImageCheck?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<UserFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<DatetimeDateFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, this action is a restock task. Use action_type to determine if a scan/image is required. */
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  isSubGenerator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this action generator is a system action. these are actions created by an admin that apply to all stores in the tenant. */
  isSystemAction?: InputMaybe<Scalars['Boolean']['input']>;
  repeatSchedule?: InputMaybe<ActionRepeatScheduleBaseFilterLookup>;
  startDate?: InputMaybe<DatetimeDateFilterLookup>;
  stores?: InputMaybe<StoreFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ActionGeneratorsInput = {
  actionGenerator?: InputMaybe<ActionGeneratorFilter>;
  actionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionShiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionTypes?: InputMaybe<Array<ActionType>>;
  endTime: Scalars['DateTime']['input'];
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemAction?: InputMaybe<Scalars['Boolean']['input']>;
  noteType?: InputMaybe<NoteTypeEnum>;
  startTime: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** ActionGroup(created, modified, id, title, tenant) */
export type ActionGroupFilter = {
  AND?: InputMaybe<ActionGroupFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionGroupFilter>;
  OR?: InputMaybe<ActionGroupFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** ActionGroup(created, modified, id, title, tenant) */
export type ActionGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type ActionGroupOrder = {
  title?: InputMaybe<Ordering>;
};

/** Action(created, modified, id, action_type, created_by, tenant, action_group, action_shift, master_category_id, title, description, due_date_time, ongoing, is_restock, ai_image_check, store, due_date, status, action_generator, closed_by, closed_date, parent_action) */
export type ActionInput = {
  actionGroupId?: InputMaybe<Scalars['ID']['input']>;
  actionShiftId?: InputMaybe<Scalars['ID']['input']>;
  actionType?: InputMaybe<ActionType>;
  /** If true, completed task images may be verified by AI after completion. */
  aiImageCheck?: InputMaybe<Scalars['Boolean']['input']>;
  complianceCriteria?: InputMaybe<Array<ComplianceCriteriaInput>>;
  createOnePerStore?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineNotificationOffsetHours?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  /** This is not necessarily dependent on due_date */
  dueDateTime?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** If true, this action is a restock task. Use action_type to determine if a scan/image is required. */
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemAction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Master category ID (from sabre) used for restock type actions */
  masterCategoryId?: InputMaybe<Scalars['String']['input']>;
  notifyActiveManager?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the action can be completed multiple times throughout the day */
  ongoing?: InputMaybe<Scalars['Boolean']['input']>;
  peopleToNotifyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  repeatSchedule?: InputMaybe<ActionRepeatSchedule>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Link to the parent action, if this is a sub-action. */
  subActions?: InputMaybe<Array<ActionInput>>;
  title: Scalars['String']['input'];
};

/** ActionNote(created, modified, id, created_by, action, created_time, note) */
export type ActionNoteFilter = {
  AND?: InputMaybe<ActionNoteFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionNoteFilter>;
  OR?: InputMaybe<ActionNoteFilter>;
  action?: InputMaybe<ActionFilter>;
  createdBy?: InputMaybe<UserFilter>;
  createdTime?: InputMaybe<DatetimeDateFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type ActionNoteOrder = {
  createdTime?: InputMaybe<Ordering>;
};

export type ActionOrder = {
  actionGroup?: InputMaybe<ActionGroupOrder>;
  actionShift?: InputMaybe<ActionShiftOrder>;
  closedBy?: InputMaybe<UserOrder>;
  closedDate?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<UserOrder>;
  dueDate?: InputMaybe<Ordering>;
  dueDateTime?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export enum ActionRepeatSchedule {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  NEVER = 'NEVER',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export type ActionRepeatScheduleBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<ActionRepeatSchedule>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<ActionRepeatSchedule>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ActionShift(created, modified, id, title, tenant) */
export type ActionShiftFilter = {
  AND?: InputMaybe<ActionShiftFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ActionShiftFilter>;
  OR?: InputMaybe<ActionShiftFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionShiftOrder = {
  title?: InputMaybe<Ordering>;
};

export enum ActionStatus {
  DONE = 'DONE',
  IGNORED = 'IGNORED',
  OPEN = 'OPEN'
}

/** Action(created, modified, id, action_type, created_by, tenant, action_group, action_shift, master_category_id, title, description, due_date_time, ongoing, is_restock, ai_image_check, store, due_date, status, action_generator, closed_by, closed_date, parent_action) */
export type ActionStatusInput = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<ActionStatus>;
};

export enum ActionType {
  COMPLIANCE_CHECK = 'COMPLIANCE_CHECK',
  PICTURE = 'PICTURE',
  PRODUCT_CAPTURE = 'PRODUCT_CAPTURE',
  SIMPLE = 'SIMPLE'
}

export type ActionTypeBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<ActionType>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<ActionType>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActionsInput = {
  actionGenerator?: InputMaybe<ActionGeneratorFilter>;
  actionGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionShiftIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  actionTypes?: InputMaybe<Array<ActionType>>;
  endTime: Scalars['DateTime']['input'];
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  noteType?: InputMaybe<NoteTypeEnum>;
  startTime: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AddNoteToActionInput = {
  actionId: Scalars['ID']['input'];
  creationTime: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
};

export type AddNoteToActionsInput = {
  actionIds: Array<Scalars['ID']['input']>;
  creationTime: Scalars['DateTime']['input'];
  note: Scalars['String']['input'];
};

export type AggregateInsightOrder = {
  numStores?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type AiInsightOrder = {
  priority?: InputMaybe<SortDirection>;
  store?: InputMaybe<SortDirection>;
  type?: InputMaybe<SortDirection>;
};

export type ArraySetting = {
  fieldName: Scalars['String']['input'];
  fieldValue: Array<Scalars['String']['input']>;
};

export type ArraySettingsInput = {
  settings: Array<ArraySetting>;
};

export type BoolBaseFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

/** BoundingBox(created, modified, id, box_set, detected_label, classified_label, predicted_upcs, classification_corrected_from_upc, is_misclassified, min_x, max_x, min_y, max_y) */
export type BoundingBoxInput = {
  detectedLabel: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  maxX: Scalars['Float']['input'];
  maxY: Scalars['Float']['input'];
  minX: Scalars['Float']['input'];
  minY: Scalars['Float']['input'];
};

/** BoundingBoxSet(created, modified, id) */
export type BoundingBoxSetInput = {
  boundingBoxes: Array<BoundingBoxInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BrandFilter = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type BulkCreateUserRowInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
  storeId?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type BulkInviteUserRowInput = {
  email: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** User(password, last_login, is_superuser, email, id, pin_number, username, first_name, last_name, job_title, date_joined, date_removed, is_active, phone_number, phone_number_verified, sms_opted_out, tenant, is_staff, supervisor, onboarding_complete, external_id, is_owner, fcm_token) */
export type BulkUserInput = {
  id: Scalars['ID']['input'];
  stores?: InputMaybe<ManyToManyInput>;
};

export type CategoryFilter = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryRevenuePercentageFilter = {
  endDate: Scalars['DateTime']['input'];
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousRangeType?: InputMaybe<PreviousRangeType>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  upc: Scalars['String']['input'];
};

export type CheckPhoneNumberVerificationCodeInput = {
  verificationCode: Scalars['String']['input'];
};

export type CheckoutSessionInput = {
  customerId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export type CleanUpUserInput = {
  firebaseId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CompleteActionStatusInput = {
  bucketFileName?: InputMaybe<Scalars['String']['input']>;
  bucketFileNames?: InputMaybe<Array<Scalars['String']['input']>>;
  completionId?: InputMaybe<Scalars['ID']['input']>;
  endTime: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ComplianceCriteriaInput = {
  maxFacings?: InputMaybe<Scalars['Int']['input']>;
  minFacings: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
};

export type CoolerStatsOrdering = {
  aiInsights?: InputMaybe<SortDirection>;
  compliance?: InputMaybe<SortDirection>;
  displayName?: InputMaybe<SortDirection>;
  displayOrder?: InputMaybe<SortDirection>;
  lastSnapshot?: InputMaybe<SortDirection>;
  profit?: InputMaybe<SortDirection>;
  revenue?: InputMaybe<SortDirection>;
};

/** ActionAIContextImage(created, modified, id, url, action_generator, bucket_file_name, type) */
export type CreateActionAIContextImageInput = {
  actionGenerator?: InputMaybe<OneToManyInput>;
  bucketFileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  type: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

/** CompetitorSnapshotImage(created, modified, point, longitude_float, latitude_float, id, bucket_file_name, url, box_set, process, user, master_category_id) */
export type CreateCompetitorSnapshotImageInput = {
  boxSet: BoundingBoxSetInput;
  bucketFileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitudeFloat: Scalars['Float']['input'];
  longitudeFloat: Scalars['Float']['input'];
  /** Master category ID (from sabre) */
  masterCategoryId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<OneToManyInput>;
};

export type CreateDaiGroupInput = {
  name: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisingRoleId?: InputMaybe<Scalars['String']['input']>;
};

/** Display(created, modified, order, id, store, display_type, name, average_depth, master_category_id, date_removed, created_by) */
export type CreateDisplayInput = {
  /** Average depth of the display in product units */
  averageDepth?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<OneToManyInput>;
  dateRemoved?: InputMaybe<Scalars['DateTime']['input']>;
  displayType?: InputMaybe<OneToManyInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Master category ID (from sabre) */
  masterCategoryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  store: OneToManyInput;
};

/** DisplaySnapshotImage(created, modified, id, bucket_file_name, url, box_set, process, display_snapshot) */
export type CreateDisplaySnapshotImageInput = {
  boxSet: BoundingBoxSetInput;
  bucketFileName: Scalars['String']['input'];
  displaySnapshot: OneToManyInput;
  id?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** DisplaySnapshot(created, modified, id, type, display, user, capture_time, planogram_segment, restock) */
export type CreateDisplaySnapshotInput = {
  captureTime?: InputMaybe<Scalars['DateTime']['input']>;
  display: OneToManyInput;
  id?: InputMaybe<Scalars['UUID']['input']>;
  image?: InputMaybe<ImageWithBoundingBoxesInput>;
  type: SnapshotType;
  user?: InputMaybe<OneToManyInput>;
};

export type CreateDisplayWithSnapshotInput = {
  display: CreateDisplayInput;
  snapshot: CreateDisplaySnapshotInput;
};

/** Invitation(created, modified, id, email, inviter, opened, invalidated) */
export type CreateInvitationInput = {
  email: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  inviterId: Scalars['UUID']['input'];
  opened?: InputMaybe<Scalars['Boolean']['input']>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Location(created, modified, point, longitude_float, latitude_float, id, address1, address2, city, state, postal_code, county, timezone, name) */
export type CreateLocationInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type CreateProductImageInput = {
  bucketFilePath: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isMarketingImage?: Scalars['Boolean']['input'];
  upc: Scalars['String']['input'];
};

export type CreateProductInput = {
  brand: Scalars['String']['input'];
  flavors?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  packaging: PackagingInput;
  upc: Scalars['String']['input'];
};

export type CreateProductSetInput = {
  description?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  products: Array<CustomProductInput>;
};

/** Annotated reference image of a display used to define expected product placement. */
export type CreateReferenceImageInput = {
  boxSet: BoundingBoxSetInput;
  bucketFileName: Scalars['String']['input'];
  description?: Scalars['String']['input'];
  productSetId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

/** RestockGroup(created, modified, id, store, action_complete, user) */
export type CreateRestockGroupInput = {
  actionComplete?: InputMaybe<ActionCompleteInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  restocks: Array<CreateRestockInput>;
  storeId: Scalars['String']['input'];
};

/** Restock(created, modified, id, display, restock_group) */
export type CreateRestockInput = {
  actionComplete?: InputMaybe<ActionCompleteInput>;
  display: OneToManyInput;
  displaySnapshots: Array<CreateDisplaySnapshotInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  picklist?: InputMaybe<Array<PicklistItemInput>>;
};

/** Store(created, modified, id, location, tenant, inactive_at, date_removed, external_store_id) */
export type CreateStoreInput = {
  /** Tenant's ID for store */
  externalStoreId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inactiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<CreateLocationInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};

/** TenantLogoImage(created, modified, id, bucket_file_name, url, tenant) */
export type CreateTenantLogoImageInput = {
  bucketFileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  tenant: OneToManyInput;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** User(password, last_login, is_superuser, email, id, pin_number, username, first_name, last_name, job_title, date_joined, date_removed, is_active, phone_number, phone_number_verified, sms_opted_out, tenant, is_staff, supervisor, onboarding_complete, external_id, is_owner, fcm_token) */
export type CreateUserInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isStaff?: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pinNumber?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** UserProfileImage(created, modified, id, bucket_file_name, url, user) */
export type CreateUserProfileImageInput = {
  bucketFileName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user: OneToManyInput;
};

export type CreateUserSessionInfoInput = {
  appVersion: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  isSharedDevice?: Scalars['Boolean']['input'];
  operatingSystem: Scalars['String']['input'];
};

export type CustomProductInput = {
  description?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  upc?: Scalars['String']['input'];
};

export enum DAIPermissionCodename {
  CAN_ADD_STORES = 'CAN_ADD_STORES',
  CAN_CREATE_TASKS = 'CAN_CREATE_TASKS',
  CAN_EDIT_COMPANY_LOGO = 'CAN_EDIT_COMPANY_LOGO',
  CAN_EDIT_SYSTEM_TASKS = 'CAN_EDIT_SYSTEM_TASKS',
  CAN_EDIT_TENANT_SETTINGS = 'CAN_EDIT_TENANT_SETTINGS',
  CAN_IMPERSONATE_USERS = 'CAN_IMPERSONATE_USERS',
  CAN_INVITE_USERS = 'CAN_INVITE_USERS',
  CAN_LOGIN_TO_WEB_APP = 'CAN_LOGIN_TO_WEB_APP',
  CAN_MANAGE_BILLING = 'CAN_MANAGE_BILLING',
  CAN_VIEW_ALL_STORES = 'CAN_VIEW_ALL_STORES',
  CAN_VIEW_STORE_POS_DATA = 'CAN_VIEW_STORE_POS_DATA'
}

export type DashboardFilter = {
  endDate: Scalars['DateTime']['input'];
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousRangeType?: InputMaybe<PreviousRangeType>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DashboardOrdering = {
  compliance?: InputMaybe<SortDirection>;
  emptyFacings?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  restockCompletion?: InputMaybe<SortDirection>;
  taskCompletion?: InputMaybe<SortDirection>;
  totalRevenue?: InputMaybe<SortDirection>;
};

export type DashboardRankFilter = {
  countToReturn?: InputMaybe<Scalars['Int']['input']>;
  endDate: Scalars['DateTime']['input'];
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousRangeType?: InputMaybe<PreviousRangeType>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  topFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatetimeDateFilterLookup = {
  day?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
  isoYear?: InputMaybe<IntComparisonFilterLookup>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  month?: InputMaybe<IntComparisonFilterLookup>;
  quarter?: InputMaybe<IntComparisonFilterLookup>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DatetimeRangeLookup>;
  week?: InputMaybe<IntComparisonFilterLookup>;
  weekDay?: InputMaybe<IntComparisonFilterLookup>;
  year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeDatetimeFilterLookup = {
  date?: InputMaybe<IntComparisonFilterLookup>;
  day?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  hour?: InputMaybe<IntComparisonFilterLookup>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  isoWeekDay?: InputMaybe<IntComparisonFilterLookup>;
  isoYear?: InputMaybe<IntComparisonFilterLookup>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  minute?: InputMaybe<IntComparisonFilterLookup>;
  month?: InputMaybe<IntComparisonFilterLookup>;
  quarter?: InputMaybe<IntComparisonFilterLookup>;
  /** Inclusive range test (between) */
  range?: InputMaybe<DatetimeRangeLookup>;
  second?: InputMaybe<IntComparisonFilterLookup>;
  time?: InputMaybe<IntComparisonFilterLookup>;
  week?: InputMaybe<IntComparisonFilterLookup>;
  weekDay?: InputMaybe<IntComparisonFilterLookup>;
  year?: InputMaybe<IntComparisonFilterLookup>;
};

export type DatetimeRangeLookup = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteActionInput = {
  actionId: Scalars['ID']['input'];
};

export type DeleteActionsInput = {
  actionIds: Array<Scalars['ID']['input']>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Display(created, modified, order, id, store, display_type, name, average_depth, master_category_id, date_removed, created_by) */
export type DeleteDisplayInput = {
  id: Scalars['ID']['input'];
};

export type DeleteObjectInput = {
  id: Scalars['ID']['input'];
};

export enum DetectedPriceType {
  BULK_OFFER = 'BULK_OFFER',
  MISC = 'MISC',
  STANDARD = 'STANDARD',
  UNKNOWN = 'UNKNOWN'
}

export type DisplayCoolerProductStatsOrdering = {
  actualAvgFacings?: InputMaybe<SortDirection>;
  averageVolumePerDay?: InputMaybe<SortDirection>;
  daysSupply?: InputMaybe<SortDirection>;
  facings?: InputMaybe<SortDirection>;
  margin?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  revenue?: InputMaybe<SortDirection>;
  revenuePerFacing?: InputMaybe<SortDirection>;
  revenueTrend?: InputMaybe<SortDirection>;
  upc?: InputMaybe<SortDirection>;
  volume?: InputMaybe<SortDirection>;
};

/** Display(created, modified, order, id, store, display_type, name, average_depth, master_category_id, date_removed, created_by) */
export type DisplayFilter = {
  AND?: InputMaybe<DisplayFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DisplayFilter>;
  OR?: InputMaybe<DisplayFilter>;
  /** Average depth of the display in product units */
  averageDepth?: InputMaybe<IntComparisonFilterLookup>;
  createdBy?: InputMaybe<DjangoModelFilterInput>;
  dateRemoved?: InputMaybe<DatetimeDatetimeFilterLookup>;
  displayType?: InputMaybe<DisplayTypeFilter>;
  id?: InputMaybe<UUIDFilterLookup>;
  /** Master category ID (from sabre) */
  masterCategoryId?: InputMaybe<StrFilterLookup>;
  store?: InputMaybe<StoreFilter>;
};

/** Display(created, modified, order, id, store, display_type, name, average_depth, master_category_id, date_removed, created_by) */
export type DisplayInput = {
  /** Average depth of the display in product units */
  averageDepth?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<OneToManyInput>;
  dateRemoved?: InputMaybe<Scalars['DateTime']['input']>;
  displayType?: InputMaybe<OneToManyInput>;
  id: Scalars['ID']['input'];
  /** Master category ID (from sabre) */
  masterCategoryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  store: OneToManyInput;
};

/** Used for OneToMany relationships when creating an object. Allows to either create nested objects or assign existing objects to the newly created object. */
export type DisplayInput__One2ManyCreateInput = {
  assign?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<DisplayInput>;
};

export type DisplayOrder = {
  averageDepth?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<Ordering>;
  dateRemoved?: InputMaybe<Ordering>;
  displayType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  masterCategoryId?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  order?: InputMaybe<Ordering>;
  store?: InputMaybe<Ordering>;
};

/** DisplaySnapshot(created, modified, id, type, display, user, capture_time, planogram_segment, restock) */
export type DisplaySnapshotFilter = {
  AND?: InputMaybe<DisplaySnapshotFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DisplaySnapshotFilter>;
  OR?: InputMaybe<DisplaySnapshotFilter>;
  actionGeneratorId?: InputMaybe<Scalars['String']['input']>;
  actionId?: InputMaybe<Scalars['String']['input']>;
  captureTime?: InputMaybe<DatetimeDatetimeFilterLookup>;
  display?: InputMaybe<DisplayFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  latestPerDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  onlyFullyClassified?: InputMaybe<Scalars['Boolean']['input']>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<SnapshotType>;
  user?: InputMaybe<UserFilter>;
};

/** DisplaySnapshotImage(created, modified, id, bucket_file_name, url, box_set, process, display_snapshot) */
export type DisplaySnapshotImageFilter = {
  AND?: InputMaybe<DisplaySnapshotImageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DisplaySnapshotImageFilter>;
  OR?: InputMaybe<DisplaySnapshotImageFilter>;
  boxSet?: InputMaybe<DjangoModelFilterInput>;
  bucketFileName?: InputMaybe<Scalars['String']['input']>;
  displaySnapshot?: InputMaybe<DjangoModelFilterInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DisplaySnapshotOrder = {
  captureTime?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  score?: InputMaybe<Ordering>;
};

/** DisplayType(created, modified, id, name) */
export type DisplayTypeFilter = {
  AND?: InputMaybe<DisplayTypeFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<DisplayTypeFilter>;
  OR?: InputMaybe<DisplayTypeFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Display(created, modified, order, id, store, display_type, name, average_depth, master_category_id, date_removed, created_by) */
export type DisplaysOrderInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type DjangoModelFilterInput = {
  id: Scalars['ID']['input'];
};

export enum GroupByDate {
  DAY = 'DAY',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export type ImageWithBoundingBoxesInput = {
  boxSet: BoundingBoxSetInput;
  bucketFileName: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export enum InsightLevel {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum InsightPriority {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum InsightSentiment {
  NEGATIVE_SENTIMENT = 'NEGATIVE_SENTIMENT',
  NEUTRAL_SENTIMENT = 'NEUTRAL_SENTIMENT',
  POSITIVE_SENTIMENT = 'POSITIVE_SENTIMENT'
}

export enum InsightState {
  ACTIVE = 'ACTIVE',
  IGNORED = 'IGNORED',
  RESOLVED = 'RESOLVED',
  SNOOZED = 'SNOOZED'
}

export enum InsightType {
  ACTION = 'ACTION',
  PRODUCT = 'PRODUCT',
  RESTOCK = 'RESTOCK'
}

export type InsightsFilter = {
  insightType?: InputMaybe<StoreInsightType>;
  language?: InputMaybe<Scalars['String']['input']>;
  /** The starting date of the window to observe for insights. Defaults to 1 week ago from today. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntComparisonFilterLookup = {
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than. Filter will be skipped on `null` value */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to. Filter will be skipped on `null` value */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than. Filter will be skipped on `null` value */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to. Filter will be skipped on `null` value */
  lte?: InputMaybe<Scalars['Int']['input']>;
  /** Inclusive range test (between) */
  range?: InputMaybe<IntRangeLookup>;
};

export type IntRangeLookup = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

/** Invitation(created, modified, id, email, inviter, opened, invalidated) */
export type InvitationFilter = {
  AND?: InputMaybe<InvitationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<InvitationFilter>;
  OR?: InputMaybe<InvitationFilter>;
  email?: InputMaybe<StrFilterLookup>;
  groups?: InputMaybe<DjangoModelFilterInput>;
  id?: InputMaybe<UUIDFilterLookup>;
  invalidated?: InputMaybe<BoolBaseFilterLookup>;
  inviter?: InputMaybe<DjangoModelFilterInput>;
  opened?: InputMaybe<BoolBaseFilterLookup>;
  stores?: InputMaybe<DjangoModelFilterInput>;
};

export type InvitationOrder = {
  email?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  invalidated?: InputMaybe<Ordering>;
  inviter?: InputMaybe<Ordering>;
  opened?: InputMaybe<Ordering>;
};

/** Location(created, modified, point, longitude_float, latitude_float, id, address1, address2, city, state, postal_code, county, timezone, name) */
export type LocationFilter = {
  AND?: InputMaybe<LocationFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<LocationFilter>;
  OR?: InputMaybe<LocationFilter>;
  address1?: InputMaybe<StrFilterLookup>;
  city?: InputMaybe<StrFilterLookup>;
  county?: InputMaybe<StrFilterLookup>;
  id?: InputMaybe<UUIDFilterLookup>;
  name?: InputMaybe<StrFilterLookup>;
  postalCode?: InputMaybe<StrFilterLookup>;
  state?: InputMaybe<StrFilterLookup>;
};

/** Location(created, modified, point, longitude_float, latitude_float, id, address1, address2, city, state, postal_code, county, timezone, name) */
export type LocationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type LocationOrder = {
  name?: InputMaybe<Ordering>;
};

export type ManyToManyInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  set?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum NoteTypeEnum {
  ALL = 'ALL',
  COMPLETIONS = 'COMPLETIONS',
  NOTES = 'NOTES'
}

export enum NotificationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export type NotificationTypeChannelsInput = {
  channels: Array<Scalars['String']['input']>;
  notificationType: Scalars['String']['input'];
};

export type OffsetLimitPaginationFilter = {
  /** The limit of the pagination window. */
  limit: Scalars['Int']['input'];
  /** The offset of the pagination window. */
  offset: Scalars['Int']['input'];
};

export type OffsetPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: Scalars['Int']['input'];
};

export type OneToManyInput = {
  set?: InputMaybe<Scalars['ID']['input']>;
};

export enum Ordering {
  ASC = 'ASC',
  ASC_NULLS_FIRST = 'ASC_NULLS_FIRST',
  ASC_NULLS_LAST = 'ASC_NULLS_LAST',
  DESC = 'DESC',
  DESC_NULLS_FIRST = 'DESC_NULLS_FIRST',
  DESC_NULLS_LAST = 'DESC_NULLS_LAST'
}

export enum POSAmountType {
  QUANTITY = 'QUANTITY',
  SALE_PRICE = 'SALE_PRICE'
}

export enum POSGroupBy {
  CATEGORY = 'CATEGORY',
  STORE = 'STORE',
  UPC = 'UPC'
}

export enum POSOperation {
  AVG = 'AVG',
  MAX = 'MAX',
  MIN = 'MIN',
  SUM = 'SUM'
}

export type PackagingInput = {
  container: PackagingType;
  quantity: Scalars['Int']['input'];
  size: Scalars['Float']['input'];
  unit: PackagingUnits;
};

export enum PackagingType {
  ALUMINUM_BOTTLE = 'ALUMINUM_BOTTLE',
  BAG = 'BAG',
  BOTTLE = 'BOTTLE',
  BOX = 'BOX',
  CAN = 'CAN',
  CANISTER = 'CANISTER',
  CARTON = 'CARTON',
  GLASS_BOTTLE = 'GLASS_BOTTLE',
  JAR = 'JAR',
  PACKET = 'PACKET'
}

export enum PackagingUnits {
  GALLONS = 'GALLONS',
  LITERS = 'LITERS',
  MILLILITERS = 'MILLILITERS',
  OUNCES = 'OUNCES'
}

export type PeerComparisonFilter = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  storeId: Scalars['String']['input'];
};

export enum PermissionCategory {
  ACTIONS = 'ACTIONS',
  BILLING = 'BILLING',
  INTERNAL = 'INTERNAL',
  SETTINGS = 'SETTINGS',
  STORES = 'STORES',
  USERS = 'USERS'
}

export type PicklistItemInput = {
  quantity: Scalars['Int']['input'];
  upc: Scalars['String']['input'];
};

export enum PlanType {
  BASIC = 'BASIC',
  ENTERPRISE = 'ENTERPRISE',
  PREMIUM = 'PREMIUM',
  PREMIUM_FREE = 'PREMIUM_FREE'
}

/** PlanogramFacing(id, created, modified, upc, shelf, column_index, quantity, v_facings) */
export type PlanogramFacingInput = {
  columnIndex: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  upc: Scalars['String']['input'];
};

/** Used for ManyToOne relationships when creating an object. Allows to either create nested objects or assign existing objects to the newly created object. */
export type PlanogramFacingInput__Many2OneCreateInput = {
  assign?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<PlanogramFacingInput>>;
};

/** Planogram(id, created, modified, display, thumbnail, created_by) */
export type PlanogramInput = {
  display?: InputMaybe<DisplayInput__One2ManyCreateInput>;
  segments?: InputMaybe<PlanogramSegmentInput__Many2OneCreateInput>;
};

/** PlanogramSegment(height, depth, width, x_offset, id, name, planogram, segment_index, left_segment) */
export type PlanogramSegmentInput = {
  segmentIndex: Scalars['Int']['input'];
  shelves?: InputMaybe<PlanogramShelfInput__Many2OneCreateInput>;
};

/** Used for ManyToOne relationships when creating an object. Allows to either create nested objects or assign existing objects to the newly created object. */
export type PlanogramSegmentInput__Many2OneCreateInput = {
  assign?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<PlanogramSegmentInput>>;
};

/** note: the y_offset is the top of the shelf */
export type PlanogramShelfInput = {
  displayShelfIndex: Scalars['Int']['input'];
  planogramfacings?: InputMaybe<PlanogramFacingInput__Many2OneCreateInput>;
  segmentShelfIndex: Scalars['Int']['input'];
};

/** Used for ManyToOne relationships when creating an object. Allows to either create nested objects or assign existing objects to the newly created object. */
export type PlanogramShelfInput__Many2OneCreateInput = {
  assign?: InputMaybe<Array<Scalars['ID']['input']>>;
  create?: InputMaybe<Array<PlanogramShelfInput>>;
};

export type PosBusyHourFilter = {
  aggregateByStoreId?: InputMaybe<Scalars['Boolean']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  operation: POSOperation;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PosIntervalFilter = {
  amountType?: InputMaybe<POSAmountType>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['DateTime']['input'];
  groupBy?: InputMaybe<POSGroupBy>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PosRevenueAndFuelFilter = {
  endDate: Scalars['DateTime']['input'];
  fuelCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  groupByStore?: InputMaybe<Scalars['Boolean']['input']>;
  insideCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  outsideCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousRangeType?: InputMaybe<PreviousRangeType>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PosRevenueAndFuelOrdering = {
  fuelVolume?: InputMaybe<SortDirection>;
  insideSales?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  outsideSales?: InputMaybe<SortDirection>;
  totalRevenue?: InputMaybe<SortDirection>;
};

export enum PreviousRangeType {
  PREVIOUS_PERIOD = 'PREVIOUS_PERIOD',
  SMART_YEAR_COMPARE = 'SMART_YEAR_COMPARE'
}

export enum ProcessStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export type ProductDashboardOrdering = {
  category?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  earningsPerFacing?: InputMaybe<SortDirection>;
  emptyFacings?: InputMaybe<SortDirection>;
  facings?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  revenuePerFacing?: InputMaybe<SortDirection>;
  sovi?: InputMaybe<SortDirection>;
  totalEarnings?: InputMaybe<SortDirection>;
  totalRevenue?: InputMaybe<SortDirection>;
  volume?: InputMaybe<SortDirection>;
  volumeDiff?: InputMaybe<SortDirection>;
  vpo?: InputMaybe<SortDirection>;
};

export type ProductFilter = {
  brandFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  isValidUpc?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAfter?: InputMaybe<Scalars['DateTime']['input']>;
  masterCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  modifiedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  orderByRelevancy?: InputMaybe<Scalars['Boolean']['input']>;
  packagingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  packagingQuantities?: InputMaybe<Array<Scalars['Int']['input']>>;
  packagingSizes?: InputMaybe<Array<Scalars['Float']['input']>>;
  packagingUnits?: InputMaybe<Array<Scalars['String']['input']>>;
  removeZeroRelevancy?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  upcs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProductFlavorFilter = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ProductsDashboardFilter = {
  brandIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['DateTime']['input'];
  groupBy?: Scalars['String']['input'];
  includePreviousPosVolume?: Scalars['Boolean']['input'];
  previousEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  previousRangeType?: InputMaybe<PreviousRangeType>;
  previousStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  upcs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Annotated reference image of a display used to define expected product placement. */
export type ReferenceImageFilter = {
  AND?: InputMaybe<ReferenceImageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<ReferenceImageFilter>;
  OR?: InputMaybe<ReferenceImageFilter>;
  bucketFileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  productSetId?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ReferencePointInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type ResolveInsightInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  snoozedUntil?: InputMaybe<Scalars['DateTime']['input']>;
  state: InsightState;
};

/** RestockGroup(created, modified, id, store, action_complete, user) */
export type RestockGroupFilter = {
  AND?: InputMaybe<RestockGroupFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<RestockGroupFilter>;
  OR?: InputMaybe<RestockGroupFilter>;
  actionComplete?: InputMaybe<ActionCompleteFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  restocks?: InputMaybe<RestocksFilter>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<UserFilter>;
};

export type RestockGroupOrder = {
  created?: InputMaybe<Ordering>;
  displaysRestocked?: InputMaybe<Ordering>;
  store?: InputMaybe<Ordering>;
  user?: InputMaybe<Ordering>;
};

/** Restock(created, modified, id, display, restock_group) */
export type RestocksFilter = {
  AND?: InputMaybe<RestocksFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<RestocksFilter>;
  OR?: InputMaybe<RestocksFilter>;
  created?: InputMaybe<DatetimeDatetimeFilterLookup>;
  display?: InputMaybe<DisplayFilter>;
  displaySnapshots?: InputMaybe<DisplaySnapshotFilter>;
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export enum SnapshotType {
  OTHER = 'OTHER',
  POST_RESTOCK = 'POST_RESTOCK',
  PRE_RESTOCK = 'PRE_RESTOCK'
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type StoreEdit = {
  store?: InputMaybe<CreateStoreInput>;
  storeId?: InputMaybe<Scalars['ID']['input']>;
  type: StoreEditType;
};

export enum StoreEditType {
  ACTIVATE = 'ACTIVATE',
  ADD = 'ADD',
  DEACTIVATE = 'DEACTIVATE',
  REMOVE = 'REMOVE'
}

/** Store(created, modified, id, location, tenant, inactive_at, date_removed, external_store_id) */
export type StoreFilter = {
  AND?: InputMaybe<StoreFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<StoreFilter>;
  OR?: InputMaybe<StoreFilter>;
  /** Tenant's ID for store */
  externalStoreId?: InputMaybe<StrFilterLookup>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  idIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location_Address1?: InputMaybe<StrFilterLookup>;
  location_City?: InputMaybe<StrFilterLookup>;
  location_Name?: InputMaybe<StrFilterLookup>;
  location_State?: InputMaybe<StrFilterLookup>;
  onlyMyStores?: InputMaybe<Scalars['Boolean']['input']>;
  referencePoint?: InputMaybe<ReferencePointInput>;
};

export type StoreInsightOrder = {
  created?: InputMaybe<SortDirection>;
  insightType?: InputMaybe<SortDirection>;
  storeId?: InputMaybe<SortDirection>;
};

export enum StoreInsightType {
  INCOMPLETE_RESTOCK = 'INCOMPLETE_RESTOCK',
  INCOMPLETE_TASK = 'INCOMPLETE_TASK',
  PRICE_MISMATCH = 'PRICE_MISMATCH',
  PRODUCT_NOT_SOLD = 'PRODUCT_NOT_SOLD',
  RECOMMENDED_SWAP = 'RECOMMENDED_SWAP',
  REVENUE_OUTLIER = 'REVENUE_OUTLIER'
}

export type StoreInsightsFilter = {
  insightType?: InputMaybe<StoreInsightType>;
  /** The starting date of the window to observe for insights. Defaults to 1 week ago from today. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  storeId: Scalars['ID']['input'];
};

export type StoreOrder = {
  isActive?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  referencePoint?: InputMaybe<Ordering>;
};

export type StorePlanogramChangesInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  storeId: Scalars['ID']['input'];
};

export type StrFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Tenant(created, modified, id, name, email_domain, is_customer, payment_customer_id, premium_access_until, language, enable_classification_monitoring) */
export type TenantInput = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** TenantLogoImage(created, modified, id, bucket_file_name, url, tenant) */
export type TenantLogoImageFilter = {
  AND?: InputMaybe<TenantLogoImageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<TenantLogoImageFilter>;
  OR?: InputMaybe<TenantLogoImageFilter>;
  bucketFileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UUIDFilterLookup = {
  /** Case-sensitive containment test. Filter will be skipped on `null` value */
  contains?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-sensitive ends-with. Filter will be skipped on `null` value */
  endsWith?: InputMaybe<Scalars['UUID']['input']>;
  /** Exact match. Filter will be skipped on `null` value */
  exact?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive containment test. Filter will be skipped on `null` value */
  iContains?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive ends-with. Filter will be skipped on `null` value */
  iEndsWith?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive exact match. Filter will be skipped on `null` value */
  iExact?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive regular expression match. Filter will be skipped on `null` value */
  iRegex?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-insensitive starts-with. Filter will be skipped on `null` value */
  iStartsWith?: InputMaybe<Scalars['UUID']['input']>;
  /** Exact match of items in a given list. Filter will be skipped on `null` value */
  inList?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Assignment test. Filter will be skipped on `null` value */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-sensitive regular expression match. Filter will be skipped on `null` value */
  regex?: InputMaybe<Scalars['UUID']['input']>;
  /** Case-sensitive starts-with. Filter will be skipped on `null` value */
  startsWith?: InputMaybe<Scalars['UUID']['input']>;
};

/** Action(created, modified, id, action_type, created_by, tenant, action_group, action_shift, master_category_id, title, description, due_date_time, ongoing, is_restock, ai_image_check, store, due_date, status, action_generator, closed_by, closed_date, parent_action) */
export type UpdateActionInput = {
  actionGroupId?: InputMaybe<Scalars['ID']['input']>;
  actionShiftId?: InputMaybe<Scalars['ID']['input']>;
  actionType?: InputMaybe<ActionType>;
  /** If true, completed task images may be verified by AI after completion. */
  aiImageCheck?: InputMaybe<Scalars['Boolean']['input']>;
  complianceCriteria?: InputMaybe<Array<ComplianceCriteriaInput>>;
  createOnePerStore?: InputMaybe<Scalars['Boolean']['input']>;
  deadlineNotificationOffsetHours?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  /** This is not necessarily dependent on due_date */
  dueDateTime?: InputMaybe<Scalars['Time']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  /** If true, this action is a restock task. Use action_type to determine if a scan/image is required. */
  isRestock?: InputMaybe<Scalars['Boolean']['input']>;
  isSystemAction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Master category ID (from sabre) used for restock type actions */
  masterCategoryId?: InputMaybe<Scalars['String']['input']>;
  notifyActiveManager?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnDeadline?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnFailure?: InputMaybe<Scalars['Boolean']['input']>;
  notifyOnSuccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the action can be completed multiple times throughout the day */
  ongoing?: InputMaybe<Scalars['Boolean']['input']>;
  peopleToNotifyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  productSetId?: InputMaybe<Scalars['ID']['input']>;
  repeatSchedule?: InputMaybe<ActionRepeatSchedule>;
  storeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Link to the parent action, if this is a sub-action. */
  subActions?: InputMaybe<Array<ActionInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActionStatusInput = {
  endTime: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDaiGroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisingRoleId?: InputMaybe<Scalars['String']['input']>;
};

/** Invitation(created, modified, id, email, inviter, opened, invalidated) */
export type UpdateInvitationInput = {
  id: Scalars['ID']['input'];
  opened?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationPreferencesInput = {
  blockedChannels: Array<Scalars['String']['input']>;
};

export type UpdateNotificationSubscriptionInput = {
  channels: Array<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

export type UpdateNotificationTypeSubscriptionsInput = {
  notificationTypeChannels: Array<NotificationTypeChannelsInput>;
};

/** Store(created, modified, id, location, tenant, inactive_at, date_removed, external_store_id) */
export type UpdateStoreInput = {
  /** Tenant's ID for store */
  externalStoreId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inactiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<CreateLocationInput>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<UserUpdateInput>;
};

export type UpdateSubscriptionPlanInput = {
  priceId: Scalars['String']['input'];
};

export type UpdateSubscriptionUnitQuantityInput = {
  storeEdits: Array<StoreEdit>;
};

export type UpdateUserNotificationSettingsInput = {
  posCriticalErrorsEnabled: Scalars['Boolean']['input'];
};

/** User(password, last_login, is_superuser, email, id, pin_number, username, first_name, last_name, job_title, date_joined, date_removed, is_active, phone_number, phone_number_verified, sms_opted_out, tenant, is_staff, supervisor, onboarding_complete, external_id, is_owner, fcm_token) */
export type UserFilter = {
  AND?: InputMaybe<UserFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<UserFilter>;
  OR?: InputMaybe<UserFilter>;
  dateRemoved?: InputMaybe<DatetimeDatetimeFilterLookup>;
  email?: InputMaybe<StrFilterLookup>;
  externalId?: InputMaybe<StrFilterLookup>;
  firstName?: InputMaybe<StrFilterLookup>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<UUIDFilterLookup>;
  isActive?: InputMaybe<BoolBaseFilterLookup>;
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser?: InputMaybe<BoolBaseFilterLookup>;
  jobTitle?: InputMaybe<StrFilterLookup>;
  lastName?: InputMaybe<StrFilterLookup>;
};

/** User(password, last_login, is_superuser, email, id, pin_number, username, first_name, last_name, job_title, date_joined, date_removed, is_active, phone_number, phone_number_verified, sms_opted_out, tenant, is_staff, supervisor, onboarding_complete, external_id, is_owner, fcm_token) */
export type UserInput = {
  dateRemoved?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  isStaff?: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  onboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pinNumber?: InputMaybe<Scalars['String']['input']>;
  storeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supervisorId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantInput>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrder = {
  dateJoined?: InputMaybe<Ordering>;
  dateRemoved?: InputMaybe<Ordering>;
  email?: InputMaybe<Ordering>;
  firstName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  jobTitle?: InputMaybe<Ordering>;
  lastName?: InputMaybe<Ordering>;
};

/** UserProfileImage(created, modified, id, bucket_file_name, url, user) */
export type UserProfileImageFilter = {
  AND?: InputMaybe<UserProfileImageFilter>;
  DISTINCT?: InputMaybe<Scalars['Boolean']['input']>;
  NOT?: InputMaybe<UserProfileImageFilter>;
  OR?: InputMaybe<UserProfileImageFilter>;
  bucketFileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<DjangoModelFilterInput>;
};

/** UserTourRecord(created, modified, id, user, tour, progress, skipped) */
export type UserTourRecordInput = {
  progress?: Scalars['Float']['input'];
  skipped?: Scalars['Boolean']['input'];
  tourName: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type UserUpdateInput = {
  add?: InputMaybe<Array<Scalars['ID']['input']>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  set?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ActionCompleteFragment = { __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, aiCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, notes: string, created: any } | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } };

export type ActionGeneratorFragmentFragment = { __typename: 'ActionGenerator', title: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null, masterCategoryId: string | null, description: string | null, startDate: any, dueDateTime: any | null, actionType: ActionType, id: string, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, notifyOnDeadline: boolean, deadlineNotificationOffsetHours: number | null, stores: Array<{ __typename: 'Store', id: string }>, parentGenerator: { __typename: 'ActionGenerator', id: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }>, subGenerators: Array<{ __typename: 'ActionGenerator', id: string, title: string, description: string | null, dueDateTime: any | null, actionType: ActionType, endDate: any | null, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, notifyOnDeadline: boolean, deadlineNotificationOffsetHours: number | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> }> };

export type ActionGeneratorStatsFragment = { __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, dueDateTime: any | null, numStores: number, storeIds: Array<string> | null, completionPercentage: number, ignoredPercentage: number, subGenerators: Array<{ __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, numStores: number, completionPercentage: number, ignoredPercentage: number }> };

export type ActionNoteFragment = { __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } };

export type AggregateInsightFragment = { __typename: 'AggregateInsight', message: string, insightType: StoreInsightType | null, sentiment: InsightSentiment | null, storeIds: Array<string> };

export type BillingDetailsFragment = { __typename: 'BillingDetails', name: string | null, email: string | null, phone: string | null, address: { __typename: 'Address', line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null } | null };

export type BillingPeriodFragment = { __typename: 'BillingPeriod', startDate: any | null, endDate: any | null };

export type BoundingBoxFragment = { __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } };

export type CardFragment = { __typename: 'Card', brand: string, last4: string, expMonth: string, expYear: string };

export type CheckoutSessionTypeFragment = { __typename: 'CheckoutSessionType', id: string, clientSecret: string | null };

export type CoolerStatsFragment = { __typename: 'CoolerStats', displayId: string, displayName: string, displayOrder: number, thumbnailUrl: string | null, revenue: number | null, revenueTrend: number | null, profit: number | null, profitTrend: number | null, complianceScore: number | null, aiInsightsCount: number | null, lastSnapshotDate: any | null, latestPlanogramChangeCreatedAt: any | null, latestPlanogramRestockCompletedAt: any | null };

export type DashboardIntervalStatFragment = { __typename: 'DashboardIntervalStat', date: string | null, totalRevenue: number | null, insideSales: number | null, emptyFacings: number | null, compliance: number | null, restockCompletion: number | null, taskCompletion: number | null };

export type DashboardStatWithPreviousFragment = { __typename: 'DashboardStatWithPrevious', id: string, name: string, totalRevenue: number | null, previousTotalRevenue: number | null, emptyFacings: number | null, previousEmptyFacings: number | null, compliance: number | null, previousCompliance: number | null, restockCompletion: number | null, previousRestockCompletion: number | null, taskCompletion: number | null, previousTaskCompletion: number | null };

export type DashboardStatFragment = { __typename: 'DashboardStat', id: string, name: string, totalRevenue: number | null, emptyFacings: number | null, compliance: number | null, restockCompletion: number | null, taskCompletion: number | null };

export type DisplayFragment = { __typename: 'Display', id: string, name: string, dateRemoved: any | null, order: number, masterCategoryId: string | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }, displayType: { __typename: 'DisplayType', id: string, name: string } | null, image: { __typename: 'ActionAIContextImage', id: string, url: string | null } | { __typename: 'ActionImage', id: string, url: string | null } | { __typename: 'CompetitorSnapshotImage', id: string, url: string | null } | { __typename: 'DisplaySnapshotImage', id: string, url: string | null } | { __typename: 'PlanogramThumbnailImage', id: string, url: string | null } | { __typename: 'ReferenceImage', id: string, url: string | null } | { __typename: 'TenantLogoImage', id: string, url: string | null } | { __typename: 'UserProfileImage', id: string, url: string | null } | null, planogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } | null };

export type DisplaySnapshotFragment = { __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, order: number, averageDepth: number, store: { __typename: 'Store', id: string } }, user: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null } | null, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, score: { __typename: 'DisplaySnapshotScore', score: number } | null, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>>, complianceInfo: { __typename: 'ComplianceInfo', planogramUpcSet: Array<string>, detectedUpcSet: Array<string>, intersectionUpcSet: Array<string>, unionUpcSet: Array<string>, missingFacings: Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>, extraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }>, flexExtraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }>, nonFlexExtraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }> } | null };

export type DisplaySnapshotImageFragment = { __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null };

export type DisplaySnapshotWithImageBoxesFragment = { __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null } }, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null, emptyFacings: Array<{ __typename: 'EmptyFacingItem', id: string, upc: string | null }>, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>> };

export type FullActionFragment = { __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, generatorStores: Array<{ __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }>, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, aiCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, notes: string, created: any } | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }>, subActions: Array<{ __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> }> };

export type GroupFragment = { __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> };

export type InsightFragment = { __typename: 'Insight', id: string | null, message: string | null, insightType: StoreInsightType, snoozedUntil: any | null, resolutionDate: any | null, store: { __typename: 'Store', id: string }, notes: Array<{ __typename: 'InsightNote', id: string, note: string }> };

export type InvitationFragment = { __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> };

export type LocationFragment = { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null };

export type ParsedCreateUserDataFragment = { __typename: 'ParsedCreateUserData', name: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, role: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, assignedStoreName: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, pin: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, email: { __typename: 'ParsedField', id: string | null, value: string, error: string | null } };

export type ParsedFacingDataFragment = { __typename: 'ParsedFacingData', upc: string, columnIndex: number, quantity: number, vFacings: number };

export type ParsedFieldFragment = { __typename: 'ParsedField', id: string | null, value: string, error: string | null };

export type ParsedSegmentDataFragment = { __typename: 'ParsedSegmentData', segmentIndex: number, shelves: Array<{ __typename: 'ParsedShelfData', segmentShelfIndex: number, displayShelfIndex: number, facings: Array<{ __typename: 'ParsedFacingData', upc: string, columnIndex: number, quantity: number, vFacings: number }> }> };

export type ParsedShelfDataFragment = { __typename: 'ParsedShelfData', segmentShelfIndex: number, displayShelfIndex: number, facings: Array<{ __typename: 'ParsedFacingData', upc: string, columnIndex: number, quantity: number, vFacings: number }> };

export type PaymentMethodFragment = { __typename: 'PaymentMethod', usingLink: boolean, card: { __typename: 'Card', brand: string, last4: string, expMonth: string, expYear: string } | null, billingDetails: { __typename: 'BillingDetails', name: string | null, email: string | null, phone: string | null, address: { __typename: 'Address', line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null } | null } | null };

export type PermissionFragment = { __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory };

export type PlanogramChangeDetailsFragment = { __typename: 'PlanogramChange', id: string, created: any, completedAt: any | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string } | null, changedBy: { __typename: 'User', id: string, firstName: string, lastName: string }, diff: { __typename: 'PlanogramDiff', summary: { __typename: 'PlanogramDiffSummary', productsAdded: number, productsRemoved: number, facingsIncreased: number, facingsDecreased: number }, products: Array<{ __typename: 'PlanogramProductChange', upc: string, changeType: string, previousFacingCount: number, newFacingCount: number }> }, previousPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> }, newPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> } };

export type PlanogramFragment = { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> };

export type PriceTypeFragment = { __typename: 'PriceType', id: string, unitAmount: string | null, currency: string, recurring: string | null, type: string };

export type CategoryRevenuePercentageFragment = { __typename: 'CategoryRevenuePercentage', upc: string, category: string | null, currentUpcRevenue: number | null, currentTotalCategoryRevenue: number | null, currentPercentage: number | null, previousUpcRevenue: number | null, previousTotalCategoryRevenue: number | null, previousPercentage: number | null, percentageChange: number | null };

export type ProductDashboardIntervalStatFragment = { __typename: 'ProductDashboardIntervalStat', id: string | null, date: any | null, category: string | null, description: string | null, totalRevenue: number | null, totalEarnings: number | null, volume: number | null, vpo: number | null, previousVolume: number | null, facings: number | null, emptyFacings: number | null, sovi: number | null, revenuePerFacing: number | null, earningsPerFacing: number | null };

export type ProductDashboardStatFragment = { __typename: 'ProductDashboardStat', id: string | null, name: string | null, category: string | null, description: string | null, totalRevenue: number | null, previousTotalRevenue: number | null, totalEarnings: number | null, volume: number | null, vpo: number | null, previousVolume: number | null, facings: number | null, emptyFacings: number | null, sovi: number | null, revenuePerFacing: number | null, earningsPerFacing: number | null };

export type ProductFragment = { __typename: 'Product', id: string, name: string | null, preferredName: string, packagingName: string | null, upcA: string, planogramImageUrl: string | null, marketingImageUrl: string | null, packaging: { __typename: 'ProductPackaging', quantity: number, size: number | null, unit: string | null } | null };

export type RankStatFragment = { __typename: 'RankStat', label: string, value: number | null, total: number | null };

export type RestockFragment = { __typename: 'Restock', id: string, created: any, display: { __typename: 'Display', id: string, name: string, dateRemoved: any | null, order: number, masterCategoryId: string | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }, displayType: { __typename: 'DisplayType', id: string, name: string } | null, image: { __typename: 'ActionAIContextImage', id: string, url: string | null } | { __typename: 'ActionImage', id: string, url: string | null } | { __typename: 'CompetitorSnapshotImage', id: string, url: string | null } | { __typename: 'DisplaySnapshotImage', id: string, url: string | null } | { __typename: 'PlanogramThumbnailImage', id: string, url: string | null } | { __typename: 'ReferenceImage', id: string, url: string | null } | { __typename: 'TenantLogoImage', id: string, url: string | null } | { __typename: 'UserProfileImage', id: string, url: string | null } | null, planogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } | null }, displaySnapshots: Array<{ __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null } }, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null, emptyFacings: Array<{ __typename: 'EmptyFacingItem', id: string, upc: string | null }>, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>> }> | null };

export type RestockGroupFragment = { __typename: 'RestockGroup', id: string, created: any, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, restocks: Array<{ __typename: 'Restock', id: string, created: any, display: { __typename: 'Display', id: string, name: string, dateRemoved: any | null, order: number, masterCategoryId: string | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }, displayType: { __typename: 'DisplayType', id: string, name: string } | null, image: { __typename: 'ActionAIContextImage', id: string, url: string | null } | { __typename: 'ActionImage', id: string, url: string | null } | { __typename: 'CompetitorSnapshotImage', id: string, url: string | null } | { __typename: 'DisplaySnapshotImage', id: string, url: string | null } | { __typename: 'PlanogramThumbnailImage', id: string, url: string | null } | { __typename: 'ReferenceImage', id: string, url: string | null } | { __typename: 'TenantLogoImage', id: string, url: string | null } | { __typename: 'UserProfileImage', id: string, url: string | null } | null, planogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } | null }, displaySnapshots: Array<{ __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null } }, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null, emptyFacings: Array<{ __typename: 'EmptyFacingItem', id: string, upc: string | null }>, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>> }> | null }>, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null }, actionComplete: { __typename: 'ActionComplete', action: { __typename: 'Action', id: string, title: string, dueDateTime: string | null, dueDate: any | null, actionGenerator: { __typename: 'ActionGenerator', id: string } | null } } | null };

export type SimpleActionGeneratorFragmentFragment = { __typename: 'ActionGenerator', id: string, title: string, dueDateTime: any | null, stores: Array<{ __typename: 'Store', id: string }> };

export type SimpleRestockGroupFragment = { __typename: 'RestockGroup', id: string, created: any, user: { __typename: 'User', firstName: string, lastName: string }, restocks: Array<{ __typename: 'Restock', id: string }>, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null }, actionComplete: { __typename: 'ActionComplete', action: { __typename: 'Action', id: string, title: string, dueDateTime: string | null, dueDate: any | null, actionGenerator: { __typename: 'ActionGenerator', id: string } | null } } | null };

export type StoreActionRankingFragment = { __typename: 'StoreActionRanking', rank: number, tasksCompletionPercentage: number, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null } };

export type StoreFragment = { __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> };

export type SubActionFragment = { __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> };

export type SubActionGeneratorStatsFragment = { __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, numStores: number, completionPercentage: number, ignoredPercentage: number };

export type SubscriptionInfoFragment = { __typename: 'SubscriptionInfo', planType: PlanType, nextPlanType: PlanType | null, id: string, planId: string, customerId: string, unitQuantity: number, centsPerUnit: number | null, monthlySubtotal: number | null, cancelAt: any | null, trialEnd: any | null, paymentMethod: { __typename: 'PaymentMethod', usingLink: boolean, card: { __typename: 'Card', brand: string, last4: string, expMonth: string, expYear: string } | null, billingDetails: { __typename: 'BillingDetails', name: string | null, email: string | null, phone: string | null, address: { __typename: 'Address', line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null } | null } | null } | null, billingPeriod: { __typename: 'BillingPeriod', startDate: any | null, endDate: any | null } | null };

export type SubscriptionTypeFragment = { __typename: 'SubscriptionType', id: string, name: string, features: Array<string>, planType: PlanType | null, description: string | null, prices: Array<{ __typename: 'PriceType', id: string, unitAmount: string | null, currency: string, recurring: string | null, type: string }> };

export type UserFragment = { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null };

export type AcknowledgeHeartbeatErrorsMutationVariables = Exact<{
  errorIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcknowledgeHeartbeatErrorsMutation = { acknowledgeHeartbeatErrors: { __typename: 'AcknowledgeHeartbeatErrorsResult', success: boolean, acknowledgedCount: number } };

export type AcknowledgeStoreInsightMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcknowledgeStoreInsightMutation = { acknowledgeStoreInsight: boolean };

export type AddNoteToActionMutationVariables = Exact<{
  input: AddNoteToActionInput;
}>;


export type AddNoteToActionMutation = { addNoteToAction: { __typename: 'ActionNote', id: string, note: string } };

export type AddNoteToActionsMutationVariables = Exact<{
  data: AddNoteToActionsInput;
}>;


export type AddNoteToActionsMutation = { addNoteToActions: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, action: { __typename: 'Action', id: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null } } }> };

export type addPremiumFreeSubscriptionMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type addPremiumFreeSubscriptionMutation = { addPremiumFreeSubscription: boolean };

export type BulkCreateUsersMutationVariables = Exact<{
  data: Array<BulkCreateUserRowInput> | BulkCreateUserRowInput;
}>;


export type BulkCreateUsersMutation = { bulkCreateUsers: Array<{ __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }> };

export type BulkSendInvitationsMutationVariables = Exact<{
  data: Array<BulkInviteUserRowInput> | BulkInviteUserRowInput;
}>;


export type BulkSendInvitationsMutation = { bulkSendInvitations: Array<{ __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> }> };

export type CancelSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type CancelSubscriptionMutation = { cancelSubscription: boolean };

export type CheckPhoneNumberVerificationCodeMutationVariables = Exact<{
  data: CheckPhoneNumberVerificationCodeInput;
}>;


export type CheckPhoneNumberVerificationCodeMutation = { checkPhoneNumberVerificationCode: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type CleanUpUserMutationVariables = Exact<{
  input: CleanUpUserInput;
}>;


export type CleanUpUserMutation = { cleanUpUser: boolean };

export type CreateActionMutationVariables = Exact<{
  input: ActionInput;
}>;


export type CreateActionMutation = { createAction: boolean };

export type CreateActionAiContextImageMutationVariables = Exact<{
  data: CreateActionAIContextImageInput;
}>;


export type CreateActionAiContextImageMutation = { createActionAiContextImage: { __typename: 'ActionAIContextImage', id: string, bucketFileName: string, url: string | null, type: string } };

export type CreateActionGroupMutationVariables = Exact<{
  input: ActionGroupInput;
}>;


export type CreateActionGroupMutation = { createActionGroup: { __typename: 'ActionGroup', id: string, title: string } };

export type CreateActionShiftMutationVariables = Exact<{
  input: ActionGroupInput;
}>;


export type CreateActionShiftMutation = { createActionShift: { __typename: 'ActionShift', id: string, title: string } };

export type CreateDaiGroupMutationVariables = Exact<{
  data: CreateDaiGroupInput;
}>;


export type CreateDaiGroupMutation = { createDaiGroup: { __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> } };

export type CreateDisplayMutationVariables = Exact<{
  data: CreateDisplayInput;
}>;


export type CreateDisplayMutation = { createDisplay: { __typename: 'Display', id: string, name: string, masterCategoryId: string | null, store: { __typename: 'Store', id: string } } };

export type CreateStoreMutationVariables = Exact<{
  data: CreateStoreInput;
}>;


export type CreateStoreMutation = { createStore: { __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> } };

export type CreateTenantLogoImageMutationVariables = Exact<{
  data: CreateTenantLogoImageInput;
}>;


export type CreateTenantLogoImageMutation = { createTenantLogoImage: { __typename: 'TenantLogoImage', url: string | null } };

export type CreateUpdatePaymentMethodPortalSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateUpdatePaymentMethodPortalSessionMutation = { createUpdatePaymentMethodPortalSession: { __typename: 'Session', url: string } };

export type CreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type CreateUserProfileImageMutationVariables = Exact<{
  data: CreateUserProfileImageInput;
}>;


export type CreateUserProfileImageMutation = { createUserProfileImage: { __typename: 'UserProfileImage', url: string | null } };

export type CreateUserTourRecordMutationVariables = Exact<{
  data: UserTourRecordInput;
}>;


export type CreateUserTourRecordMutation = { createUserTourRecord: { __typename: 'UserTourRecord', tour: { __typename: 'UserTour', id: string, name: string } } };

export type DeleteActionMutationVariables = Exact<{
  input: DeleteActionInput;
}>;


export type DeleteActionMutation = { deleteAction: boolean };

export type DeleteActionAiContextImageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteActionAiContextImageMutation = { deleteActionAiContextImage: boolean };

export type DeleteActionGeneratorMutationVariables = Exact<{
  input: DeleteObjectInput;
}>;


export type DeleteActionGeneratorMutation = { deleteActionGenerator: boolean };

export type DeleteActionGroupMutationVariables = Exact<{
  input: DeleteObjectInput;
}>;


export type DeleteActionGroupMutation = { deleteActionGroup: { __typename: 'ActionGroup', id: string } };

export type DeleteActionShiftMutationVariables = Exact<{
  input: DeleteObjectInput;
}>;


export type DeleteActionShiftMutation = { deleteActionShift: { __typename: 'ActionShift', id: string } };

export type DeleteActionsMutationVariables = Exact<{
  input: DeleteActionsInput;
}>;


export type DeleteActionsMutation = { deleteActions: boolean };

export type DeleteDaiGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDaiGroupMutation = { deleteDaiGroup: boolean };

export type DeleteDisplayMutationVariables = Exact<{
  data: DeleteDisplayInput;
}>;


export type DeleteDisplayMutation = { deleteDisplay: { __typename: 'Display', id: string, name: string } };

export type DeleteStoreMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStoreMutation = { deleteStore: { __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> } };

export type ParseCreateUserCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ParseCreateUserCsvMutation = { parseCreateUserCsv: Array<{ __typename: 'ParsedCreateUserData', name: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, role: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, assignedStoreName: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, pin: { __typename: 'ParsedField', id: string | null, value: string, error: string | null }, email: { __typename: 'ParsedField', id: string | null, value: string, error: string | null } }> };

export type ParsePsaFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ParsePsaFileMutation = { parsePsaFile: { __typename: 'ParsedPlanogramData', segments: Array<{ __typename: 'ParsedSegmentData', segmentIndex: number, shelves: Array<{ __typename: 'ParsedShelfData', segmentShelfIndex: number, displayShelfIndex: number, facings: Array<{ __typename: 'ParsedFacingData', upc: string, columnIndex: number, quantity: number, vFacings: number }> }> }> } };

export type RenewSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['String']['input'];
}>;


export type RenewSubscriptionMutation = { renewSubscription: boolean };

export type ResendInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { resendInvitation: { __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type ResolveInsightMutationVariables = Exact<{
  data: ResolveInsightInput;
}>;


export type ResolveInsightMutation = { resolveInsight: boolean };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreUserMutation = { restoreUser: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type SendInvitationMutationVariables = Exact<{
  data: CreateInvitationInput;
}>;


export type SendInvitationMutation = { sendInvitation: { __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type SendPhoneNumberVerificationCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type SendPhoneNumberVerificationCodeMutation = { sendPhoneNumberVerificationCode: boolean };

export type SetPlanogramMutationVariables = Exact<{
  data: PlanogramInput;
}>;


export type SetPlanogramMutation = { createPlanogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } };

export type SoftDeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SoftDeleteUserMutation = { softDeleteUser: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type UpdateActionMutationVariables = Exact<{
  input: UpdateActionInput;
}>;


export type UpdateActionMutation = { updateAction: boolean };

export type UpdateDaiGroupMutationVariables = Exact<{
  data: UpdateDaiGroupInput;
}>;


export type UpdateDaiGroupMutation = { updateDaiGroup: { __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> } };

export type UpdateDisplayMutationVariables = Exact<{
  data: DisplayInput;
}>;


export type UpdateDisplayMutation = { updateDisplay: { __typename: 'Display', id: string, name: string, averageDepth: number, store: { __typename: 'Store', id: string } } };

export type UpdateDisplaysOrderMutationVariables = Exact<{
  filters: DisplayFilter;
  data: Array<DisplaysOrderInput> | DisplaysOrderInput;
}>;


export type UpdateDisplaysOrderMutation = { updateDisplaysOrder: Array<{ __typename: 'Display', id: string, order: number }> };

export type UpdateInvitationMutationVariables = Exact<{
  data: UpdateInvitationInput;
}>;


export type UpdateInvitationMutation = { updateInvitation: { __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  data: UpdateNotificationPreferencesInput;
}>;


export type UpdateNotificationPreferencesMutation = { updateNotificationPreferences: { __typename: 'UserNotificationPreferences', blockedChannels: Array<string> } };

export type UpdateNotificationSubscriptionMutationVariables = Exact<{
  data: UpdateNotificationSubscriptionInput;
}>;


export type UpdateNotificationSubscriptionMutation = { updateNotificationSubscription: { __typename: 'NotificationSubscription', id: number, channels: Array<string>, rule: { __typename: 'NotificationRule', id: number, name: string, targetId: string, targetType: string, triggerCondition: string } } };

export type UpdateNotificationTypeSubscriptionsMutationVariables = Exact<{
  data: UpdateNotificationTypeSubscriptionsInput;
}>;


export type UpdateNotificationTypeSubscriptionsMutation = { updateNotificationTypeSubscriptions: Array<{ __typename: 'NotificationTypeChannelPreference', notificationType: string, channels: Array<string> }> };

export type UpdateStoreMutationVariables = Exact<{
  data: UpdateStoreInput;
}>;


export type UpdateStoreMutation = { updateStore: { __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> } };

export type UpdateSubscriptionPlanMutationVariables = Exact<{
  input: UpdateSubscriptionPlanInput;
}>;


export type UpdateSubscriptionPlanMutation = { updateSubscriptionPlan: { __typename: 'UpdateSubscriptionResult', success: boolean, subscriptionId: string, quantity: number } };

export type UpdateSubscriptionUnitQuantityMutationVariables = Exact<{
  input: UpdateSubscriptionUnitQuantityInput;
}>;


export type UpdateSubscriptionUnitQuantityMutation = { updateSubscriptionUnitQuantity: { __typename: 'UpdateSubscriptionResult', success: boolean, subscriptionId: string, quantity: number } };

export type UpdateTenantArraySettingsMutationVariables = Exact<{
  data: ArraySettingsInput;
}>;


export type UpdateTenantArraySettingsMutation = { updateTenantArraySettings: { __typename: 'ArraySettings', insideSalesCategories: Array<string>, outsideSalesCategories: Array<string>, fuelSalesCategories: Array<string> } };

export type UpdateTenantTableColumnVisibilityMutationVariables = Exact<{
  tableId: Scalars['String']['input'];
  hiddenColumns: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTenantTableColumnVisibilityMutation = { updateTenantTableColumnVisibility: { __typename: 'TableColumnVisibilitySettings', tableId: string, tenantHiddenColumns: Array<string>, userHiddenColumns: Array<string>, effectiveHiddenColumns: Array<string> } };

export type UpdateUserMutationVariables = Exact<{
  data: UserInput;
}>;


export type UpdateUserMutation = { updateUser: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type UpdateUserTableColumnVisibilityMutationVariables = Exact<{
  tableId: Scalars['String']['input'];
  hiddenColumns: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateUserTableColumnVisibilityMutation = { updateUserTableColumnVisibility: { __typename: 'TableColumnVisibilitySettings', tableId: string, tenantHiddenColumns: Array<string>, userHiddenColumns: Array<string>, effectiveHiddenColumns: Array<string> } };

export type ActiveSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveSubscriptionQuery = { activeSubscription: { __typename: 'SubscriptionInfo', planType: PlanType, nextPlanType: PlanType | null, id: string, planId: string, customerId: string, unitQuantity: number, centsPerUnit: number | null, monthlySubtotal: number | null, cancelAt: any | null, trialEnd: any | null, paymentMethod: { __typename: 'PaymentMethod', usingLink: boolean, card: { __typename: 'Card', brand: string, last4: string, expMonth: string, expYear: string } | null, billingDetails: { __typename: 'BillingDetails', name: string | null, email: string | null, phone: string | null, address: { __typename: 'Address', line1: string | null, line2: string | null, city: string | null, state: string | null, postalCode: string | null, country: string | null } | null } | null } | null, billingPeriod: { __typename: 'BillingPeriod', startDate: any | null, endDate: any | null } | null } | null };

export type GetActionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActionQuery = { action: { __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, generatorStores: Array<{ __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }>, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, aiCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, notes: string, created: any } | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }>, subActions: Array<{ __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> }> } };

export type GetActionGeneratorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  actionFilters?: InputMaybe<ActionFilter>;
}>;


export type GetActionGeneratorQuery = { actionGenerator: { __typename: 'ActionGenerator', id: string, title: string, description: string | null, startDate: any, endDate: any | null, dueDateTime: any | null, repeatSchedule: ActionRepeatSchedule, actionType: ActionType, parentGenerator: { __typename: 'ActionGenerator', id: string, title: string } | null, subGenerators: Array<{ __typename: 'ActionGenerator', id: string, title: string, description: string | null, dueDateTime: any | null, actionType: ActionType, repeatSchedule: ActionRepeatSchedule }>, aiContextImages: Array<{ __typename: 'ActionAIContextImage', id: string, url: string | null, type: string }>, actions: Array<{ __typename: 'Action', id: string, title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, status: ActionStatus, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null }> } };

export type GetActionGeneratorStatsQueryVariables = Exact<{
  filters: ActionGeneratorsInput;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetActionGeneratorStatsQuery = { actionGeneratorStats: { __typename: 'ActionGeneratorStatsPaginationWindow', totalCount: number, results: Array<{ __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, dueDateTime: any | null, numStores: number, storeIds: Array<string> | null, completionPercentage: number, ignoredPercentage: number, subGenerators: Array<{ __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, numStores: number, completionPercentage: number, ignoredPercentage: number }> }> } };

export type GetActionGeneratorStatsSingleQueryVariables = Exact<{
  generatorId: Scalars['ID']['input'];
  filters: ActionGeneratorsInput;
}>;


export type GetActionGeneratorStatsSingleQuery = { actionGeneratorStatsSingle: { __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, dueDateTime: any | null, numStores: number, storeIds: Array<string> | null, completionPercentage: number, ignoredPercentage: number, subGenerators: Array<{ __typename: 'ActionGeneratorStats', id: string, title: string, description: string | null, repeatSchedule: ActionRepeatSchedule, startDate: any, actionType: ActionType, numStores: number, completionPercentage: number, ignoredPercentage: number }> } };

export type GetActionGeneratorStoresQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  storeFilters?: InputMaybe<StoreFilter>;
}>;


export type GetActionGeneratorStoresQuery = { actionGenerator: { __typename: 'ActionGenerator', id: string, title: string, dueDateTime: any | null, isSystemAction: boolean, stores: Array<{ __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null }> } };

export type GetActionGeneratorsQueryVariables = Exact<{
  filters?: InputMaybe<ActionGeneratorFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  subFilters?: InputMaybe<ActionGeneratorFilter>;
  subPagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetActionGeneratorsQuery = { tenantActionGenerators: { __typename: 'ActionGeneratorOffsetPaginated', totalCount: number, results: Array<{ __typename: 'ActionGenerator', title: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null, masterCategoryId: string | null, description: string | null, startDate: any, dueDateTime: any | null, actionType: ActionType, id: string, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, notifyOnDeadline: boolean, deadlineNotificationOffsetHours: number | null, stores: Array<{ __typename: 'Store', id: string }>, parentGenerator: { __typename: 'ActionGenerator', id: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }>, subGenerators: Array<{ __typename: 'ActionGenerator', id: string, title: string, description: string | null, dueDateTime: any | null, actionType: ActionType, endDate: any | null, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, notifyOnDeadline: boolean, deadlineNotificationOffsetHours: number | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> }> }> } };

export type GetActionGeneratorsSimpleQueryVariables = Exact<{
  filters: ActionGeneratorFilter;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetActionGeneratorsSimpleQuery = { tenantActionGenerators: { __typename: 'ActionGeneratorOffsetPaginated', totalCount: number, results: Array<{ __typename: 'ActionGenerator', id: string, title: string, dueDateTime: any | null, stores: Array<{ __typename: 'Store', id: string }> }> } };

export type GetTenantActionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantActionGroupsQuery = { tenantActionGroups: Array<{ __typename: 'ActionGroup', title: string, id: string }> };

export type GetActionNotesAndCompletionsQueryVariables = Exact<{
  filters: ActionsInput;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetActionNotesAndCompletionsQuery = { tenantActionNotesAndCompletions: { __typename: 'ActionNoteActionCompletePaginationWindow', totalCount: number, results: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, aiCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, notes: string, created: any } | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } } | { __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }> } };

export type GetTenantActionShiftsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantActionShiftsQuery = { tenantActionShifts: Array<{ __typename: 'ActionShift', title: string, id: string }> };

export type GetActionsQueryVariables = Exact<{
  filters?: InputMaybe<ActionFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  order?: InputMaybe<ActionOrder>;
}>;


export type GetActionsQuery = { tenantActions: { __typename: 'ActionOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, generatorStores: Array<{ __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }>, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, aiCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, notes: string, created: any } | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, action: { __typename: 'Action', title: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }>, subActions: Array<{ __typename: 'Action', title: string, description: string | null, dueDate: any | null, dueDateTime: string | null, actionType: ActionType, id: string, status: ActionStatus, aiImageCheck: boolean, notifyOnFailure: boolean, notifyOnSuccess: boolean, notifyActiveManager: boolean, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }, actionGenerator: { __typename: 'ActionGenerator', id: string, repeatSchedule: ActionRepeatSchedule, endDate: any | null } | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, city: string, state: string, postalCode: string } | null }, notes: Array<{ __typename: 'ActionNote', id: string, note: string, createdTime: any | null, createdBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, closedBy: { __typename: 'User', id: string } | null, actionGroup: { __typename: 'ActionGroup', id: string, title: string } | null, actionShift: { __typename: 'ActionShift', id: string, title: string } | null, completions: Array<{ __typename: 'ActionComplete', id: string, startTime: any | null, endTime: any, images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } }>, parentAction: { __typename: 'Action', id: string, title: string } | null, peopleToNotify: Array<{ __typename: 'User', id: string, firstName: string, lastName: string, email: string | null }> }> }> } };

export type GetActionsCompletedOverTimeQueryVariables = Exact<{
  filters: ActionsInput;
  groupBy: GroupByDate;
}>;


export type GetActionsCompletedOverTimeQuery = { actionsCompletedOverTime: Array<{ __typename: 'NumeratorDenominatorOverTime', date: any, numerator: number, denominator: number }> };

export type ActionsCompletionPercentageQueryVariables = Exact<{
  data: ActionsInput;
}>;


export type ActionsCompletionPercentageQuery = { actionsPercentCompleted: { __typename: 'PercentageStats', numerator: number | null, denominator: number | null } };

export type AggregateDashboardStatsQueryVariables = Exact<{
  filters: DashboardFilter;
}>;


export type AggregateDashboardStatsQuery = { aggregateDashboardStats: { __typename: 'DashboardStatWithPrevious', id: string, name: string, totalRevenue: number | null, previousTotalRevenue: number | null, emptyFacings: number | null, previousEmptyFacings: number | null, compliance: number | null, previousCompliance: number | null, restockCompletion: number | null, previousRestockCompletion: number | null, taskCompletion: number | null, previousTaskCompletion: number | null } };

export type GetAiActionCheckResultQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAiActionCheckResultQuery = { aiActionCheckResult: { __typename: 'AIActionCheckResult', id: string, passed: boolean, actionComplete: { __typename: 'ActionComplete', images: Array<{ __typename: 'ActionImage', id: string, url: string | null }> | null } } };

export type GetAllTenantStoresQueryVariables = Exact<{
  filters?: InputMaybe<StoreFilter>;
  order?: InputMaybe<StoreOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetAllTenantStoresQuery = { allTenantStores: { __typename: 'StoreOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, pageInfo: { __typename: 'OffsetPaginationInfo', limit: number | null, offset: number } } };

export type GetAvailablePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailablePlansQuery = { availablePlans: Array<{ __typename: 'SubscriptionType', id: string, name: string, features: Array<string>, planType: PlanType | null, description: string | null, prices: Array<{ __typename: 'PriceType', id: string, unitAmount: string | null, currency: string, recurring: string | null, type: string }> }> };

export type GetCheckoutSessionQueryVariables = Exact<{
  input: CheckoutSessionInput;
}>;


export type GetCheckoutSessionQuery = { checkoutSession: { __typename: 'CheckoutSessionType', id: string, clientSecret: string | null } };

export type DashboardStatsQueryVariables = Exact<{
  filters: DashboardFilter;
  order?: InputMaybe<DashboardOrdering>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type DashboardStatsQuery = { dashboardStats: { __typename: 'DashboardStatPaginationWindow', totalCount: number, results: Array<{ __typename: 'DashboardStat', id: string, name: string, totalRevenue: number | null, emptyFacings: number | null, compliance: number | null, restockCompletion: number | null, taskCompletion: number | null }> } };

export type GetDisplayQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDisplayQuery = { display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null }, planogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> } | null } };

export type DisplayCoolerProductHoverStatsQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  upc: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DisplayCoolerProductHoverStatsQuery = { displayCoolerProductHoverStats: { __typename: 'DisplayCoolerProductHoverStats', upc: string, name: string, revenue: number | null, revenueTrend: number | null, averageVolumePerDay: number | null, revenueSeries: Array<{ __typename: 'DisplayCoolerProductRevenuePoint', date: any, revenue: number | null }> } | null };

export type GetDisplayCoolerProductStatsQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
  ordering?: InputMaybe<DisplayCoolerProductStatsOrdering>;
}>;


export type GetDisplayCoolerProductStatsQuery = { displayCoolerProductStats: { __typename: 'DisplayCoolerProductStatPaginationWindow', totalCount: number, results: Array<{ __typename: 'DisplayCoolerProductStat', upc: string, name: string, revenue: number | null, revenueTrend: number | null, margin: number | null, volume: number | null, facings: number | null, revenuePerFacing: number | null, averageVolumePerDay: number | null, daysSupply: number | null }> } };

export type GetDisplayCoolerSummaryStatsQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetDisplayCoolerSummaryStatsQuery = { displayCoolerSummaryStats: { __typename: 'DisplayCoolerSummaryStats', displayId: string, complianceScore: number | null, lastSnapshotDate: any | null, revenue: number | null, revenueTrend: number | null } | null };

export type DisplayCoolerTrendingProductsStatsQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type DisplayCoolerTrendingProductsStatsQuery = { displayCoolerTrendingProductsStats: { __typename: 'DisplayCoolerTrendingProductsStats', mostIncreasingProduct: { __typename: 'DisplayCoolerTrendProduct', upc: string, name: string, revenue: number, revenueTrend: number } | null, mostDecreasingProduct: { __typename: 'DisplayCoolerTrendProduct', upc: string, name: string, revenue: number, revenueTrend: number } | null, risingProducts: Array<{ __typename: 'DisplayCoolerTrendProduct', upc: string, name: string, revenue: number, revenueTrend: number }>, fallingProducts: Array<{ __typename: 'DisplayCoolerTrendProduct', upc: string, name: string, revenue: number, revenueTrend: number }> } | null };

export type GetDisplayPlanogramHistoryQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetDisplayPlanogramHistoryQuery = { displayPlanogramHistoryCount: number, displayPlanogramHistory: Array<{ __typename: 'PlanogramChange', id: string, created: any, completedAt: any | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string } | null, changedBy: { __typename: 'User', id: string, firstName: string, lastName: string }, diff: { __typename: 'PlanogramDiff', summary: { __typename: 'PlanogramDiffSummary', productsAdded: number, productsRemoved: number, facingsIncreased: number, facingsDecreased: number }, products: Array<{ __typename: 'PlanogramProductChange', upc: string, changeType: string, previousFacingCount: number, newFacingCount: number }> }, previousPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> }, newPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> } }> };

export type GetDisplayPlanogramPerformanceHistoryQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetDisplayPlanogramPerformanceHistoryQuery = { displayPlanogramHistoryCount: number, displayPlanogramPerformanceHistory: Array<{ __typename: 'PlanogramPerformanceHistoryEntry', performanceStartAt: any | null, performanceEndAt: any | null, measuredDays: number | null, totalRevenue: number | null, averageDailyRevenue: number | null, change: { __typename: 'PlanogramChange', id: string, created: any, completedAt: any | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string } | null, changedBy: { __typename: 'User', id: string, firstName: string, lastName: string }, diff: { __typename: 'PlanogramDiff', summary: { __typename: 'PlanogramDiffSummary', productsAdded: number, productsRemoved: number, facingsIncreased: number, facingsDecreased: number }, products: Array<{ __typename: 'PlanogramProductChange', upc: string, changeType: string, previousFacingCount: number, newFacingCount: number }> }, previousPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> }, newPlanogram: { __typename: 'Planogram', shapedUpcs: Array<Array<Array<string>>> } } }> };

export type GetDisplaySnapshotQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDisplaySnapshotQuery = { displaySnapshot: { __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null } }, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null, emptyFacings: Array<{ __typename: 'EmptyFacingItem', id: string, upc: string | null }>, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>> } };

export type GetDisplaySnapshotsQueryVariables = Exact<{
  filters: DisplaySnapshotFilter;
  order?: InputMaybe<DisplaySnapshotOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetDisplaySnapshotsQuery = { tenantDisplaySnapshots: { __typename: 'DisplaySnapshotOffsetPaginated', totalCount: number, results: Array<{ __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, order: number, averageDepth: number, store: { __typename: 'Store', id: string } }, user: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null } | null, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, score: { __typename: 'DisplaySnapshotScore', score: number } | null, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>>, complianceInfo: { __typename: 'ComplianceInfo', planogramUpcSet: Array<string>, detectedUpcSet: Array<string>, intersectionUpcSet: Array<string>, unionUpcSet: Array<string>, missingFacings: Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>, extraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }>, flexExtraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }>, nonFlexExtraBoundingBoxes: Array<{ __typename: 'BoundingBox', id: string, classifiedLabel: string | null }> } | null }> } };

export type GetEmployeeActionCompletionQueryVariables = Exact<{
  filters: ActionsInput;
  order?: InputMaybe<SortDirection>;
}>;


export type GetEmployeeActionCompletionQuery = { employeeActionCompletion: Array<{ __typename: 'UserActionRanking', numberOfCompletions: number, rank: number, user: { __typename: 'User', id: string } }> };

export type GetEmptyFacingsCountQueryVariables = Exact<{
  filters: DashboardFilter;
}>;


export type GetEmptyFacingsCountQuery = { emptyFacingsCount: { __typename: 'GenericStat', label: string, value: number | null, previousValue: number | null } };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { groups: { __typename: 'DAIGroupOffsetPaginated', results: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type DashboardStatsIntervalQueryVariables = Exact<{
  filters: DashboardFilter;
}>;


export type DashboardStatsIntervalQuery = { intervalDashboardStats: { __typename: 'DashboardIntervalStatResults', period: GroupByDate, results: Array<{ __typename: 'DashboardIntervalStat', date: string | null, totalRevenue: number | null, insideSales: number | null, emptyFacings: number | null, compliance: number | null, restockCompletion: number | null, taskCompletion: number | null }> } };

export type GetInvitationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvitationQuery = { invitation: { __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type GetLatestDisplayPlanogramChangeQueryVariables = Exact<{
  displayId: Scalars['ID']['input'];
}>;


export type GetLatestDisplayPlanogramChangeQuery = { displayPlanogramHistory: Array<{ __typename: 'PlanogramChange', id: string, created: any, completedAt: any | null, completedBy: { __typename: 'User', id: string, firstName: string, lastName: string } | null }> };

export type GetLeastCompletedActionsQueryVariables = Exact<{
  filters: ActionGeneratorsInput;
}>;


export type GetLeastCompletedActionsQuery = { leastCompletedActions: Array<{ __typename: 'ActionGeneratorCompletionStats', id: string, title: string, description: string | null, completionPercentage: number, totalActions: number, completedActions: number, dueDateTime: any | null }> };

export type GetLoggedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserQuery = { loggedInUser: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null };

export type GetMasterCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterCategoriesQuery = { masterCategories: { __typename: 'MasterCategoryPaginationWindow', results: Array<{ __typename: 'MasterCategory', id: string, name: string }> } };

export type GetMissingFromPlanogramsStatsQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type GetMissingFromPlanogramsStatsQuery = { missingFromPlanogramsStats: { __typename: 'MissingFromPlanogramsStats', revenue: number | null, profit: number | null, products: Array<{ __typename: 'MissingProduct', upc: string, name: string, revenue: number, imageUrl: string | null }> } };

export type GetNotificationChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationChannelsQuery = { notificationChannels: Array<string> };

export type GetNotificationTypeChannelPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTypeChannelPreferencesQuery = { notificationTypeChannelPreferences: Array<{ __typename: 'NotificationTypeChannelPreference', notificationType: string, channels: Array<string> }> };

export type GetNotificationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTypesQuery = { notificationTypes: Array<{ __typename: 'NotificationTypeInfo', name: string, validChannels: Array<NotificationChannel>, canOptOut: boolean }> };

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionsQuery = { permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> };

export type GetPosBusyHoursQueryVariables = Exact<{
  filters: PosBusyHourFilter;
}>;


export type GetPosBusyHoursQuery = { posBusyHours: Array<{ __typename: 'BusyHourStat', hour: number, quantity: number | null, storeId: string | null }> };

export type GetPosCategoriesQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetPosCategoriesQuery = { posCategories: { __typename: 'PosCategoryPaginationWindow', totalCount: number, results: Array<{ __typename: 'PosCategory', category: string }> } };

export type GetPosIntervalStatsQueryVariables = Exact<{
  filters: PosIntervalFilter;
}>;


export type GetPosIntervalStatsQuery = { posIntervalStats: { __typename: 'PosIntervalStatResults', period: GroupByDate, results: Array<{ __typename: 'PosIntervalStat', label: string | null, date: string | null, value: number | null }> } };

export type GetPosProductInfoQueryVariables = Exact<{
  upc: Scalars['String']['input'];
}>;


export type GetPosProductInfoQuery = { posProductInfo: { __typename: 'PosProductInfo', upc: string, description: string | null, category: string | null } | null };

export type GetPosRevenueAndFuelStatsQueryVariables = Exact<{
  filters: PosRevenueAndFuelFilter;
  order?: InputMaybe<PosRevenueAndFuelOrdering>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetPosRevenueAndFuelStatsQuery = { posRevenueAndFuelStats: { __typename: 'PosRevenueAndFuelStatPaginationWindow', totalCount: number, results: Array<{ __typename: 'PosRevenueAndFuelStat', name: string | null, storeId: string | null, totalRevenue: number | null, previousTotalRevenue: number | null, insideSales: number | null, previousInsideSales: number | null, outsideSales: number | null, previousOutsideSales: number | null, fuelVolume: number | null, previousFuelVolume: number | null }> } };

export type IntervalProductsDashboardStatsQueryVariables = Exact<{
  filters?: InputMaybe<ProductsDashboardFilter>;
}>;


export type IntervalProductsDashboardStatsQuery = { intervalProductsDashboardStats: { __typename: 'ProductDashboardIntervalStatResults', period: GroupByDate | null, results: Array<{ __typename: 'ProductDashboardIntervalStat', id: string | null, date: any | null, category: string | null, description: string | null, totalRevenue: number | null, totalEarnings: number | null, volume: number | null, vpo: number | null, previousVolume: number | null, facings: number | null, emptyFacings: number | null, sovi: number | null, revenuePerFacing: number | null, earningsPerFacing: number | null }> } };

export type GetProductsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetProductsQuery = { products: { __typename: 'ProductPaginationWindow', totalCount: number, results: Array<{ __typename: 'Product', id: string, name: string | null, preferredName: string, packagingName: string | null, upcA: string, planogramImageUrl: string | null, marketingImageUrl: string | null, packaging: { __typename: 'ProductPackaging', quantity: number, size: number | null, unit: string | null } | null }> } };

export type ProductsDashboardStatsQueryVariables = Exact<{
  filters?: InputMaybe<ProductsDashboardFilter>;
  ordering?: InputMaybe<ProductDashboardOrdering>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type ProductsDashboardStatsQuery = { productsDashboardStats: { __typename: 'ProductDashboardStatPaginationWindow', totalCount: number, results: Array<{ __typename: 'ProductDashboardStat', id: string | null, name: string | null, category: string | null, description: string | null, totalRevenue: number | null, previousTotalRevenue: number | null, totalEarnings: number | null, volume: number | null, vpo: number | null, previousVolume: number | null, facings: number | null, emptyFacings: number | null, sovi: number | null, revenuePerFacing: number | null, earningsPerFacing: number | null }> } };

export type GetRestockGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRestockGroupQuery = { restockGroup: { __typename: 'RestockGroup', id: string, created: any, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, restocks: Array<{ __typename: 'Restock', id: string, created: any, display: { __typename: 'Display', id: string, name: string, dateRemoved: any | null, order: number, masterCategoryId: string | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }, displayType: { __typename: 'DisplayType', id: string, name: string } | null, image: { __typename: 'ActionAIContextImage', id: string, url: string | null } | { __typename: 'ActionImage', id: string, url: string | null } | { __typename: 'CompetitorSnapshotImage', id: string, url: string | null } | { __typename: 'DisplaySnapshotImage', id: string, url: string | null } | { __typename: 'PlanogramThumbnailImage', id: string, url: string | null } | { __typename: 'ReferenceImage', id: string, url: string | null } | { __typename: 'TenantLogoImage', id: string, url: string | null } | { __typename: 'UserProfileImage', id: string, url: string | null } | null, planogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } | null }, displaySnapshots: Array<{ __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null } }, user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null, emptyFacings: Array<{ __typename: 'EmptyFacingItem', id: string, upc: string | null }>, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null, process: { __typename: 'Process', id: string, status: ProcessStatus, error: string | null } | null, boxSet: { __typename: 'BoundingBoxSet', boundingBoxes: Array<{ __typename: 'BoundingBox', id: string, detectedLabel: string, classifiedLabel: string | null, minX: number, minY: number, maxX: number, maxY: number, boxSet: { __typename: 'BoundingBoxSet', id: string } }> } | null }>, planogramSegmentShapedFacings: Array<Array<{ __typename: 'PlanogramFacing', id: string, upc: string }>> }> | null }>, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null }, actionComplete: { __typename: 'ActionComplete', action: { __typename: 'Action', id: string, title: string, dueDateTime: string | null, dueDate: any | null, actionGenerator: { __typename: 'ActionGenerator', id: string } | null } } | null } };

export type GetSimpleActionGeneratorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSimpleActionGeneratorQuery = { actionGenerator: { __typename: 'ActionGenerator', id: string, title: string, description: string | null, startDate: any, endDate: any | null, dueDateTime: any | null, repeatSchedule: ActionRepeatSchedule, actionType: ActionType, parentGenerator: { __typename: 'ActionGenerator', id: string, title: string } | null, subGenerators: Array<{ __typename: 'ActionGenerator', id: string, title: string, description: string | null, dueDateTime: any | null, actionType: ActionType, repeatSchedule: ActionRepeatSchedule }> } };

export type GetSimpleDisplaySnapshotsQueryVariables = Exact<{
  filters: DisplaySnapshotFilter;
  order?: InputMaybe<DisplaySnapshotOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetSimpleDisplaySnapshotsQuery = { tenantDisplaySnapshots: { __typename: 'DisplaySnapshotOffsetPaginated', totalCount: number, results: Array<{ __typename: 'DisplaySnapshot', id: string, captureTime: any | null, display: { __typename: 'Display', id: string, name: string, store: { __typename: 'Store', location: { __typename: 'Location', name: string } | null } }, user: { __typename: 'User', id: string, firstName: string, lastName: string, email: string | null } | null, score: { __typename: 'DisplaySnapshotScore', score: number } | null }> } };

export type GetSimpleProductQueryVariables = Exact<{
  upc: Scalars['String']['input'];
}>;


export type GetSimpleProductQuery = { product: { __typename: 'Product', id: string, name: string | null, preferredName: string, packagingName: string | null, upcA: string, planogramImageUrl: string | null, marketingImageUrl: string | null, commonName: { __typename: 'ProductNamedRelation', id: string | null, name: string } | null, brand: { __typename: 'ProductNamedRelation', name: string } | null, manufacturer: { __typename: 'ProductNamedRelation', name: string } | null, category: { __typename: 'ProductNamedRelation', name: string } | null, packaging: { __typename: 'ProductPackaging', quantity: number, size: number | null, unit: string | null, packagingString: string | null } | null } | null };

export type GetSimpleProductsQueryVariables = Exact<{
  filters?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetSimpleProductsQuery = { products: { __typename: 'ProductPaginationWindow', totalCount: number, results: Array<{ __typename: 'Product', id: string, name: string | null, preferredName: string, packagingName: string | null, upcA: string, planogramImageUrl: string | null, marketingImageUrl: string | null, commonName: { __typename: 'ProductNamedRelation', id: string | null, name: string } | null, brand: { __typename: 'ProductNamedRelation', name: string } | null, manufacturer: { __typename: 'ProductNamedRelation', name: string } | null, category: { __typename: 'ProductNamedRelation', name: string } | null, packaging: { __typename: 'ProductPackaging', quantity: number, size: number | null, unit: string | null, packagingString: string | null } | null }> } };

export type GetStoreQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStoreQuery = { store: { __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> } };

export type GetStoreActionCompletionQueryVariables = Exact<{
  filters: ActionsInput;
  order?: InputMaybe<SortDirection>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetStoreActionCompletionQuery = { storeActionCompletion: { __typename: 'StoreActionRankingPaginationWindow', totalCount: number, results: Array<{ __typename: 'StoreActionRanking', rank: number, tasksCompletionPercentage: number, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null } }> } };

export type GetStoreCoolerPlansQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
}>;


export type GetStoreCoolerPlansQuery = { storeCoolerPlans: Array<{ __typename: 'CoolerPlan', displayId: string, displayName: string, displayOrder: number, thumbnailUrl: string | null }> };

export type GetStoreCoolerStatsQueryVariables = Exact<{
  storeId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
  ordering?: InputMaybe<CoolerStatsOrdering>;
}>;


export type GetStoreCoolerStatsQuery = { storeCoolerStats: { __typename: 'CoolerStatsPaginationWindow', totalCount: number, results: Array<{ __typename: 'CoolerStats', displayId: string, displayName: string, displayOrder: number, thumbnailUrl: string | null, revenue: number | null, revenueTrend: number | null, profit: number | null, profitTrend: number | null, complianceScore: number | null, aiInsightsCount: number | null, lastSnapshotDate: any | null, latestPlanogramChangeCreatedAt: any | null, latestPlanogramRestockCompletedAt: any | null }> } };

export type GetStorePeerComparisonsQueryVariables = Exact<{
  filters: PeerComparisonFilter;
}>;


export type GetStorePeerComparisonsQuery = { storePeerComparisons: Array<{ __typename: 'RankStat', label: string, value: number | null, total: number | null }> };

export type GetStoreSimpleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStoreSimpleQuery = { store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null } };

export type GetSyncClientInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSyncClientInformationQuery = { tenantDaiSalesSyncClientInfo: any };

export type IncompleteTaskMetadataFragment = { __typename: 'IncompleteTaskMetadata', insightId: string, message: string, missingActionIds: Array<string>, dueDate: any };

export type IncompleteRestockMetadataFragment = { __typename: 'IncompleteRestockMetadata', insightId: string, message: string, missingActionIds: Array<string>, dueDate: any };

export type RevenueOutlierMetadataFragment = { __typename: 'RevenueOutlierMetadata', insightId: string, message: string, relativeChangeDates: Array<any>, relativeChangeValues: Array<number>, relativeChangeIsOutlier: Array<boolean>, populationWindow: number, categories: Array<Array<Array<string>>> };

export type RecommendedSwapMetadataFragment = { __typename: 'RecommendedSwapMetadata', insightId: string, message: string, displayId: string, oldUpc: string, oldCurrentFacings: number, newUpc: string, newCurrentFacings: number };

export type PriceMismatchMetadataFragment = { __typename: 'PriceMismatchMetadata', insightId: string, message: string, displayId: string, date: any, upc: string, expectedUnitPrice: number, detectedUnitPrice: number, detectedPriceType: DetectedPriceType, detectedPriceText: string };

export type ProductNotSoldMetadataFragment = { __typename: 'ProductNotSoldMetadata', insightId: string, message: string, upc: string, historicalRevenue: number, lastSeenDate: any };

export type GetTenantAiInsightsQueryVariables = Exact<{
  filter?: InputMaybe<InsightsFilter>;
  order?: InputMaybe<AiInsightOrder>;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetTenantAiInsightsQuery = { tenantAiInsights: { __typename: 'InsightPaginationWindow', totalCount: number, results: Array<{ __typename: 'Insight', priority: InsightPriority, sentiment: InsightSentiment | null, insightType: StoreInsightType, summary: string, startDate: any | null, endDate: any | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null }, metadata: Array<{ __typename: 'IncompleteRestockMetadata', insightId: string, message: string, missingActionIds: Array<string>, dueDate: any } | { __typename: 'IncompleteTaskMetadata', insightId: string, message: string, missingActionIds: Array<string>, dueDate: any } | { __typename: 'PriceMismatchMetadata', insightId: string, message: string, displayId: string, date: any, upc: string, expectedUnitPrice: number, detectedUnitPrice: number, detectedPriceType: DetectedPriceType, detectedPriceText: string } | { __typename: 'ProductNotSoldMetadata', insightId: string, message: string, upc: string, historicalRevenue: number, lastSeenDate: any } | { __typename: 'RecommendedSwapMetadata', insightId: string, message: string, displayId: string, oldUpc: string, oldCurrentFacings: number, newUpc: string, newCurrentFacings: number } | { __typename: 'RevenueOutlierMetadata', insightId: string, message: string, relativeChangeDates: Array<any>, relativeChangeValues: Array<number>, relativeChangeIsOutlier: Array<boolean>, populationWindow: number, categories: Array<Array<Array<string>>> }> }> } };

export type getTenantArraySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type getTenantArraySettingsQuery = { tenantArraySettings: { __typename: 'ArraySettings', insideSalesCategories: Array<string>, outsideSalesCategories: Array<string>, fuelSalesCategories: Array<string> } };

export type GetTenantDisplaysQueryVariables = Exact<{
  filters?: InputMaybe<DisplayFilter>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  order?: InputMaybe<DisplayOrder>;
}>;


export type GetTenantDisplaysQuery = { tenantDisplays: { __typename: 'DisplayOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Display', id: string, name: string, dateRemoved: any | null, order: number, masterCategoryId: string | null, store: { __typename: 'Store', id: string, location: { __typename: 'Location', id: string, name: string } | null }, displayType: { __typename: 'DisplayType', id: string, name: string } | null, image: { __typename: 'ActionAIContextImage', id: string, url: string | null } | { __typename: 'ActionImage', id: string, url: string | null } | { __typename: 'CompetitorSnapshotImage', id: string, url: string | null } | { __typename: 'DisplaySnapshotImage', id: string, url: string | null } | { __typename: 'PlanogramThumbnailImage', id: string, url: string | null } | { __typename: 'ReferenceImage', id: string, url: string | null } | { __typename: 'TenantLogoImage', id: string, url: string | null } | { __typename: 'UserProfileImage', id: string, url: string | null } | null, planogram: { __typename: 'Planogram', id: string, shapedUpcs: Array<Array<Array<string>>> } | null }> } };

export type GetTenantGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantGroupsQuery = { tenantGroups: { __typename: 'DAIGroupOffsetPaginated', results: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> } };

export type GetTenantInvitationsQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<InvitationFilter>;
  order?: InputMaybe<InvitationOrder>;
}>;


export type GetTenantInvitationsQuery = { tenantInvitations: { __typename: 'InvitationOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Invitation', id: string, email: string, opened: boolean, invalidated: boolean, inviter: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null }, stores: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, supervisingRole: { __typename: 'DAIGroup', id: string } | null, permissions: Array<{ __typename: 'DAIPermission', id: string, name: string, codename: DAIPermissionCodename, category: PermissionCategory }> }> }>, pageInfo: { __typename: 'OffsetPaginationInfo', limit: number | null, offset: number } } };

export type GetTenantPOSStoreIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantPOSStoreIdsQuery = { tenantPosStoreIds: Array<string> };

export type GetTenantRestockGroupsQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<RestockGroupFilter>;
  order?: InputMaybe<RestockGroupOrder>;
}>;


export type GetTenantRestockGroupsQuery = { tenantRestockGroups: { __typename: 'RestockGroupOffsetPaginated', totalCount: number, results: Array<{ __typename: 'RestockGroup', id: string, created: any, user: { __typename: 'User', firstName: string, lastName: string }, restocks: Array<{ __typename: 'Restock', id: string }>, store: { __typename: 'Store', id: string, location: { __typename: 'Location', name: string } | null }, actionComplete: { __typename: 'ActionComplete', action: { __typename: 'Action', id: string, title: string, dueDateTime: string | null, dueDate: any | null, actionGenerator: { __typename: 'ActionGenerator', id: string } | null } } | null }> } };

export type GetTenantStoresQueryVariables = Exact<{
  filters?: InputMaybe<StoreFilter>;
  order?: InputMaybe<StoreOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetTenantStoresQuery = { tenantStores: { __typename: 'StoreOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Store', id: string, externalStoreId: string | null, inactiveAt: any | null, hasRecentHeartbeat: boolean, lastHeartbeatTimestamp: any | null, clientVersion: string | null, hasErrorsOnLatestHeartbeat: boolean, recentErrors: Array<{ __typename: 'HeartbeatError', id: string, errorTimestamp: any, component: string, message: string, severity: string | null }>, recentErrorsGrouped: Array<{ __typename: 'GroupedHeartbeatError', component: string, normalizedMessage: string, sampleMessage: string, firstOccurrence: any, lastOccurrence: any, count: number, errorIds: Array<string>, severity: string }>, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null, users: Array<{ __typename: 'User', id: string, isActive: boolean }> }>, pageInfo: { __typename: 'OffsetPaginationInfo', limit: number | null, offset: number } } };

export type GetTenantStoresSimpleQueryVariables = Exact<{
  filters?: InputMaybe<StoreFilter>;
  order?: InputMaybe<StoreOrder>;
  pagination?: InputMaybe<OffsetPaginationInput>;
}>;


export type GetTenantStoresSimpleQuery = { tenantStores: { __typename: 'StoreOffsetPaginated', totalCount: number, results: Array<{ __typename: 'Store', id: string, inactiveAt: any | null, location: { __typename: 'Location', id: string, name: string, address1: string, address2: string, city: string, postalCode: string, state: string, county: string | null } | null }> } };

export type GetTenantUsersQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<UserFilter>;
  order?: InputMaybe<UserOrder>;
}>;


export type GetTenantUsersQuery = { tenantUsers: { __typename: 'UserOffsetPaginated', totalCount: number, results: Array<{ __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, jobTitle: string | null, pinNumber: string | null, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean }>, stores: Array<{ __typename: 'Store', id: string }> }>, pageInfo: { __typename: 'OffsetPaginationInfo', limit: number | null, offset: number } } };

export type GetTopEmptyFacingsSnapshotsQueryVariables = Exact<{
  filters: DashboardFilter;
  pagination?: InputMaybe<OffsetLimitPaginationFilter>;
}>;


export type GetTopEmptyFacingsSnapshotsQuery = { topEmptyFacingsSnapshots: { __typename: 'DisplaySnapshotPaginationWindow', totalCount: number, results: Array<{ __typename: 'DisplaySnapshot', id: string, created: any, captureTime: any | null, type: string, display: { __typename: 'Display', id: string, name: string }, images: Array<{ __typename: 'DisplaySnapshotImage', id: string, url: string | null }> }> } };

export type GetTopEmptyProductsQueryVariables = Exact<{
  filters: DashboardRankFilter;
}>;


export type GetTopEmptyProductsQuery = { topEmptyProducts: Array<{ __typename: 'RankStat', label: string, value: number | null, total: number | null, rankValue: number | null }> };

export type GetTopEmptyStoresQueryVariables = Exact<{
  filters: DashboardRankFilter;
}>;


export type GetTopEmptyStoresQuery = { topEmptyStores: Array<{ __typename: 'RankStat', label: string, value: number | null, total: number | null, rankValue: number | null }> };

export type GetUniquePinNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUniquePinNumberQuery = { uniquePinNumber: string };

export type UPCDictQueryVariables = Exact<{
  upcs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UPCDictQuery = { upcDict: Array<{ __typename: 'UpcDictEntry', upc: string, matches: Array<string> }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { user: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } };

export type GetUserByFirebaseIdQueryVariables = Exact<{
  firebaseId: Scalars['String']['input'];
}>;


export type GetUserByFirebaseIdQuery = { userByFirebaseId: { __typename: 'User', id: string, email: string | null, firstName: string, lastName: string, username: string, isActive: boolean, phoneNumber: string | null, phoneNumberVerified: boolean, smsOptedOut: boolean, jobTitle: string | null, pinNumber: string | null, isOwner: boolean, isSuperuser: boolean, isStaff: boolean, externalId: string | null, dateJoined: any, dateRemoved: any | null, hasMultipleStores: boolean, activeSubscription: PlanType | null, onboardingComplete: boolean, tenant: { __typename: 'Tenant', id: string, name: string, paymentCustomerId: string | null, logoImage: { __typename: 'TenantLogoImage', url: string | null } | null } | null, groups: Array<{ __typename: 'DAIGroup', id: string, name: string, isOwner: boolean, permissions: Array<{ __typename: 'DAIPermission', id: string, codename: DAIPermissionCodename, name: string, category: PermissionCategory }>, manageableRoles: Array<{ __typename: 'DAIGroup', id: string, name: string }> }>, stores: Array<{ __typename: 'Store', id: string }>, supervisor: { __typename: 'User', id: string, email: string | null } | null, profileImage: { __typename: 'UserProfileImage', url: string | null } | null, notificationSettings: { __typename: 'UserNotificationSettings', posCriticalErrorsEnabled: boolean } | null } | null };

export type GetUserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationPreferencesQuery = { userNotificationPreferences: { __typename: 'UserNotificationPreferences', blockedChannels: Array<string> } | null };

export type GetUserNotificationSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserNotificationSubscriptionsQuery = { userNotificationSubscriptions: Array<{ __typename: 'NotificationSubscription', id: number, channels: Array<string>, rule: { __typename: 'NotificationRule', id: number, name: string, targetId: string, targetType: string, triggerCondition: string } }> };

export type GetLoggedInUserTourRecordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoggedInUserTourRecordQuery = { loggedInUser: { __typename: 'User', id: string, tourRecords: Array<{ __typename: 'UserTourRecord', id: string, skipped: boolean, progress: number, tour: { __typename: 'UserTour', id: string, name: string } }> } | null };

export type PinIsAvailableQueryVariables = Exact<{
  pinNumber: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PinIsAvailableQuery = { pinIsAvailable: boolean };

export type PreviewPlanChangeInvoiceQueryVariables = Exact<{
  input: UpdateSubscriptionPlanInput;
}>;


export type PreviewPlanChangeInvoiceQuery = { previewPlanChangeInvoice: { __typename: 'PreviewInvoiceResult', subtotal: number, totalTaxes: number, total: number, amountDue: number, currency: string, lines: Array<{ __typename: 'LineItem', amount: number, description: string, currency: string }> } };

export type PreviewUnitQuantityChangeInvoiceQueryVariables = Exact<{
  input: UpdateSubscriptionUnitQuantityInput;
}>;


export type PreviewUnitQuantityChangeInvoiceQuery = { previewUnitQuantityChangeInvoice: { __typename: 'PreviewInvoiceResult', subtotal: number, totalTaxes: number, total: number, amountDue: number, currency: string, lines: Array<{ __typename: 'LineItem', amount: number, description: string, currency: string }> } };

export type ProductCategoryRevenuePercentageQueryVariables = Exact<{
  filters: CategoryRevenuePercentageFilter;
}>;


export type ProductCategoryRevenuePercentageQuery = { categoryRevenuePercentage: { __typename: 'CategoryRevenuePercentage', upc: string, category: string | null, currentUpcRevenue: number | null, currentTotalCategoryRevenue: number | null, currentPercentage: number | null, previousUpcRevenue: number | null, previousTotalCategoryRevenue: number | null, previousPercentage: number | null, percentageChange: number | null } | null };

export type UserTableColumnSettingsQueryVariables = Exact<{
  tableId: Scalars['String']['input'];
}>;


export type UserTableColumnSettingsQuery = { userTableColumnSettings: { __typename: 'TableColumnVisibilitySettings', tableId: string, tenantHiddenColumns: Array<string>, userHiddenColumns: Array<string>, effectiveHiddenColumns: Array<string> } };
